import React from "react";
import {
  CBadge,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CRow,
  CButton,
  CTooltip,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CTabs,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormGroup,
  CLabel,
  CInput,
  CSelect,
  CInputFile,
  CInputGroup,
  CInputGroupText,
} from "@coreui/react";
import {
  FaFileUpload,
  FaFileAlt,
  FaEye,
  FaPen,
  FaDownload,
  FaTrashAlt,
  FaCloudDownloadAlt,
  FaPlus,
} from "react-icons/fa";
import CIcon from "@coreui/icons-react";
import { connect } from "react-redux";
import { imgurl } from "src/actions/types";
import processedCountriesData from "../login/countriesData";
import * as CountryCityStatePackage from "countrycitystatejson";
import { createLink, sendMail } from "../../actions/paymentGetwayAction";
import "../Organization/Appoinment.css";
import copy from "../../assets/images/copy.png";
import excel from "../../assets/images/excel.png";
import csv from "../../assets/images/csv.png";
import pdf from "../../assets/images/pdf.png";
import print from "../../assets/images/print.png";
import menu from "../../assets/images/menu1.png";
import editw from "../../assets/images/editw.png";
import rclose from "../../assets/images/rclose.png";
import trashw from "../../assets/images/trashw.png";
import password from "../../assets/images/password.png";
import userPlaceholder from "../../assets/images/user.jpg";
import closeKeImg from "../../assets/images/close.png";
import user from "../../assets/images/user.jpg";
import GlobalLoader from "../humanresource/GlobalLoader";
import { getUser, updateUser } from "../../actions/loginAction";
import FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  getChanelPartner,
  deleteChanelPartner,
  updateChanelPartner,
  getChanelPartnerMapping,
  updateChanelPartnerMapping,
  getChannelPartnerDoc,
  createChannelPartnerDoc,
  updateChannelPartnerDoc,
  deleteChannelPartnerDoc,
  getChannelPartnerPayoutAll,
  getChannelPartnerPayoutBalance,
} from "../../actions/setuphospitalechannelpartnerAction";
import { getAccountMainLedgerMaster } from "../../actions/setuphospitaleincomeAction";
import { getAllTransaction } from "../../actions/TransactionAction";
import { getSalesOrders } from "../../actions/setupsalesordersAction";

import {
  getDepartment,
  getDesignation,
} from "../../actions/setuphospitalehrsettingAction";
import { getProduct } from "../../actions/setuphospitaleproductgroupAction";
import { getAllPaymentGetway } from "../../actions/paymentGetwayAction";
import { getAccountMainBankMaster } from "../../actions/setuphospitaleincomeAction";
import { getAccountLedgerbyid } from "../../actions/setuphospitaleincomeAction";
import {
  getChannelPrtnerPayout,
  createChannelPrtnerPayout,
} from "../../actions/channelPartnerPayoutAction";
import {
  getChannelPartnerSetup,
  getChannelPartnerSource,
  createChannelPartnerSource,
} from "../../actions/setupChannelPartnerAction";
import {
  getAccountPersonal,
  setSelectedAccountData,
} from "../../actions/setuphospitaleaccountAction";
import {
  getChannelPartnerCommissionLog,
  updateChannelPartnerCommissionLog,
} from "../../actions/channelPartnerCommissionLogAction";
const { getCities } = CountryCityStatePackage;
const S3_BUCKET_URL = imgurl;
const getValidationStyle = (val) => ({
  borderColor: val === "" || val === undefined || val === null ? "red" : "",
});

const dropdownStyles = {
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  zIndex: 2000,
  backgroundColor: "#fff",
  border: "1px solid #d8dbe0",
  borderRadius: "4px",
  maxHeight: "150px",
  overflowY: "auto",
  padding: "0",
  margin: "0",
  listStyle: "none",
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
};
const generateRandomPassword = () => {
  const randomDigits = Math.floor(1000 + Math.random() * 9000);
  return `Partner@${randomDigits}`;
};
class PartnerProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      docModal: false,
      isProcessingDoc: false,
      currentDocType: "",
      last_name: "",
      uploadedDocuments: [],
      docDeleteModal: false,
      selectedDurations: {},
      selectedFeatureId: null,
      currency: "INR",
      docToDelete: null,
      selectedPartnerId: null,
      selectedPartnerName: "",
      embedModal: false,
      partnerData: this.props.location?.state?.partner_name
        ? this.props.location.state
        : null,
      deleteModal: false,
      messageAlert: false,
      message: "",
      customerDetailModal: false,
      selectedCustomer: null,
      customerSearchText: "",
      editModal: false,
      commissionModal: false,
      isProcessing: false,
      system_name: "",
      system_logo: null,
      system_logo_path: "",
      security_deposit_amount: "",
      displaySystemLogo: false,
      partner_id: "",
      partner_name: "",
      dob: "",
      email: "",
      phone: "",
      address_line1: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
      gst_number: "",
      pan_number: "",
      bank_name: "",
      bank_account_no: "",
      bank_ifsc: "",
      upi_id: "",
      is_active: 1,
      partner_photo: null,
      partner_photo_path: "",
      resetModal: false,
      newPassword: "",
      isEditingPassword: false,
      mapping_id: null,
      override_calc_type: "PERCENTAGE",
      override_value: "",

      provincesList: [],
      citiesList: [],
      modaladdproject: false,
      channelSearch: "",
      countrySearch: "",
      stateSearch: "",
      citySearch: "",
      showChannelDrop: false,
      showCountryDrop: false,
      showStateDrop: false,
      showCityDrop: false,
      selectedChannelInfo: null,
      btn: "Update",

      showPayoutModal: false,
      selectedBankLedgerId: "",
      selectedGateway: "cashfree",
      payoutAmount: 0,
      payoutNote: "",
      paymentMode: "bank",
      repaymentMode: "EMI",
      maxPayoutAmount: 0,
      isLoadingInvoices: false,

      selectedSources: [],
      sourceSearch: "",
      showSourceDrop: false,
      sourceModalOpen: false,
      newSourceName: "",
      newSourceStatus: 1,
      sourceError: false,
    };
    this.targetRef = React.createRef();
    this.channelRef = React.createRef();
    this.countryRef = React.createRef();
    this.stateRef = React.createRef();
    this.cityRef = React.createRef();
    this.sourceRef = React.createRef();
    this.docFileInputRef = React.createRef();
    this.handleDurationChange = this.handleDurationChange.bind(this);
    this.toggleFeature = this.toggleFeature.bind(this);
    this.formatCurrency = this.formatCurrency.bind(this);
  }
  getHospitalId = () => {
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.hid
    ) {
      const compositeParam = this.props.match.params.hid.toString();
      if (compositeParam.length > 18) {
        return compositeParam.slice(0, compositeParam.length - 18);
      }
      return compositeParam;
    }
    return localStorage.getItem("hospitalCode")?.toString();
  };
  async componentDidMount() {
    const hospitalCode = localStorage.getItem("hospitalCode")?.toString();
    if (!hospitalCode) {
      this.setState({ isLoading: false });
      return;
    }

    const loggedInRole = localStorage.getItem("StaffRole");
    const loggedInUsername = localStorage.getItem("username");
    const savedPartnerId = localStorage.getItem("selectedPartnerId");
    const HospitalId = JSON.stringify({ hid: hospitalCode });

    try {
      await Promise.all([
        this.props.getChanelPartnerMapping(HospitalId),
        this.props.getChanelPartner(HospitalId),
        this.props.getUser(HospitalId),
        this.props.getChannelPartnerSetup(HospitalId),
        this.props.getAccountMainBankMaster(HospitalId),
        this.props.getAllPaymentGetway(HospitalId),
        this.props.getDepartment(HospitalId),
        this.props.getSalesOrders(HospitalId),
        this.props.getAllTransaction(HospitalId),
        this.props.getChannelPartnerDoc(HospitalId),
        this.props.getAccountMainLedgerMaster(HospitalId),
        this.props.getProduct(HospitalId),
        this.props.getChannelPartnerSource(HospitalId),
      ]);

      this.recoverData(savedPartnerId);

      document.addEventListener("mousedown", this.handleClickOutside);
    } catch (err) {
      console.error("Data Load Error:", err);
      this.setState({ isLoading: false });
    }
  }
  componentDidUpdate(prevProps) {
    if (
      !this.state.partnerData &&
      this.props.channelPartnerList !== prevProps.channelPartnerList
    ) {
      const savedId = localStorage.getItem("selectedPartnerId");
      this.recoverData(savedId);
    }
  }
  openDocModal = async (partner) => {
    if (!partner || !partner.partner_id) {
      console.error("Partner data missing");
      return;
    }

    this.setState({
      docModal: true,
      selectedPartnerId: partner.partner_id,
      selectedPartnerName: partner.partner_name,
      uploadedDocuments: [],
      isProcessingDoc: true,
      currentDocType: "",
    });

    const payload = JSON.stringify({
      partner_id: partner.partner_id,
      hid: localStorage.getItem("hospitalCode"),
    });

    try {
      if (this.props.getChannelPartnerDoc) {
        await this.props.getChannelPartnerDoc(payload);

        const existingDocs = (this.props.channelPartnerDocList || [])
          .filter(
            (doc) => String(doc.partner_id) === String(partner.partner_id),
          )
          .map((doc) => ({
            id: doc.id,
            docId: doc.id,
            docType: doc.Document_type,
            file: { name: doc.Document.split("-").pop() },
            preview: S3_BUCKET_URL + doc.Document,
            isExisting: true,
          }));

        this.setState({ uploadedDocuments: existingDocs });
      }
    } catch (error) {
      console.log("Error fetching docs:", error);
    } finally {
      this.setState({ isProcessingDoc: false });
    }
  };

  handleDocFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!this.state.currentDocType) {
      alert("Please select document type first!");
      return;
    }
    const newDoc = {
      id: Date.now() + Math.random(),
      file: file,
      docType: this.state.currentDocType,
      preview: URL.createObjectURL(file),
      isExisting: false,
    };
    this.setState({
      uploadedDocuments: [...this.state.uploadedDocuments, newDoc],
      currentDocType: "",
    });
    e.target.value = "";
  };

  handleDeleteDoc = (doc) => {
    if (!doc.isExisting) {
      this.setState({
        uploadedDocuments: this.state.uploadedDocuments.filter(
          (d) => d.id !== doc.id,
        ),
      });
    } else {
      this.setState({ docDeleteModal: true, docToDelete: doc });
    }
  };
  handleSourceSelect = (source) => {
    if (!this.state.selectedSources.includes(source.source_name)) {
      this.setState({
        selectedSources: [...this.state.selectedSources, source.source_name],
        sourceSearch: "",
        showSourceDrop: false,
      });
    } else {
      this.setState({ showSourceDrop: false, sourceSearch: "" });
    }
  };

  removeSource = (sourceName) => {
    this.setState({
      selectedSources: this.state.selectedSources.filter(
        (item) => item !== sourceName,
      ),
    });
  };

  handleQuickSaveSource = async () => {
    const { newSourceName, newSourceStatus } = this.state;
    const { sourceTypeList } = this.props;
    const hid = localStorage.getItem("hospitalCode")?.toString();
    if (!newSourceName || newSourceName.trim() === "") {
      this.setState({
        sourceError: true,
        message: "Please enter source type name",
        messageAlert: true,
      });
      return;
    }

    const isDuplicate = (sourceTypeList || []).some(
      (item) =>
        (item.sourceType || "").trim().toUpperCase() ===
        newSourceName.trim().toUpperCase(),
    );

    if (isDuplicate) {
      this.setState({
        message: "This Source Type Name already exists!",
        messageAlert: true,
        sourceError: true,
      });
      return;
    }

    const payload = {
      hid: hid,
      sourceType: newSourceName.trim().toUpperCase(),
      action: parseInt(newSourceStatus),
    };

    try {
      this.setState({ isProcessing: true, sourceError: false });
      await this.props.createChannelPartnerSource(payload);
      await this.props.getChannelPartnerSource({ hid });
      this.setState({
        newSourceName: "",
        message: "Source Type Created Successfully",
        messageAlert: true,
        isProcessing: false,
        sourceError: false,
      });
    } catch (err) {
      console.error("Error saving source type:", err);
      this.setState({
        message: "Error saving source type. Please try again.",
        messageAlert: true,
        isProcessing: false,
        sourceError: false,
      });
    }
  };
  confirmDeleteDoc = async () => {
    const { docToDelete, uploadedDocuments } = this.state;
    const hid = localStorage.getItem("hospitalCode");
    this.setState({ isProcessingDoc: true, docDeleteModal: false });
    try {
      await this.props.deleteChannelPartnerDoc(
        JSON.stringify({ id: docToDelete.docId, hid }),
      );
      this.setState({
        uploadedDocuments: uploadedDocuments.filter(
          (doc) => doc.docId !== docToDelete.docId,
        ),
        message: "Document Deleted Successfully!",
        messageAlert: true,
        isProcessingDoc: false,
      });
    } catch (error) {
      this.setState({ isProcessingDoc: false });
    }
  };

  handleSavePartnerDocs = async () => {
    const { uploadedDocuments, selectedPartnerId } = this.state;
    const hid = localStorage.getItem("hospitalCode");
    const newDocsToCreate = uploadedDocuments.filter((doc) => !doc.isExisting);

    if (newDocsToCreate.length === 0) {
      this.setState({
        message: "No new documents to save!",
        messageAlert: true,
      });
      return;
    }

    this.setState({ isProcessingDoc: true });
    try {
      for (const doc of newDocsToCreate) {
        const formData = new FormData();
        formData.append("partner_id", selectedPartnerId);
        formData.append("hid", hid);
        formData.append("Document", doc.file);
        formData.append("Document_type", doc.docType);
        await this.props.createChannelPartnerDoc(formData);
      }
      this.setState({
        docModal: false,
        message: "Documents saved successfully!",
        messageAlert: true,
      });
      this.props.getChannelPartnerDoc(JSON.stringify({ hid }));
    } catch (error) {
      this.setState({
        message: "Error uploading documents!",
        messageAlert: true,
      });
    } finally {
      this.setState({ isProcessingDoc: false });
    }
  };
  handleSuccessOk = async () => {
    const currentHid = localStorage.getItem("hospitalCode")?.toString();

    this.setState({
      messageAlert: false,
      sourceModalOpen: false,
      modaladdproject: false,
      newSourceName: "",
      isLoading: true,
    });

    const hospitalPayload = JSON.stringify({ hid: currentHid });
    try {
      await Promise.all([
        this.props.getChanelPartner(hospitalPayload),
        this.props.getChannelPartnerSource({ hid: currentHid }),
      ]);
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleExecutePayout = async () => {
    const { partnerData } = this.state;
    const hospitalID = localStorage.getItem("hospitalCode") || "0";

    const deptList =
      this.props.departmentList?.data || this.props.departmentList || [];
    const target = "INTL SALES";
    const matchedDept = deptList.find(
      (d) =>
        (d.departmentName || "").toLowerCase() === target.toLowerCase() ||
        (d.departmentKey || "").toLowerCase() === target.toLowerCase(),
    );
    const finalDept = matchedDept ? matchedDept.departmentKey : "INTL SALES";

    const selectedBank = this.props.AccountMainBankMasterList?.find(
      (b) => String(b.LedgerID) === String(this.state.selectedBankLedgerId),
    );

    if (!selectedBank) {
      this.setState({
        message: "Please select a source bank account.",
        messageAlert: true,
      });
      return;
    }

    const payload = {
      gateway: this.state.selectedGateway,
      hospitalID: parseInt(hospitalID),
      amount: parseFloat(this.state.payoutAmount),
      currency: "INR",
      payment_mode: this.state.paymentMode,
      beneficiary_name: partnerData.partner_name,
      beneficiary_email: partnerData.email,
      beneficiary_phone: partnerData.phone,
      account_number: partnerData.bank_account_no,
      ifsc: partnerData.bank_ifsc,
      entity_reference_id: String(partnerData.partner_id),
      entity_reference_type: "tbl_channelpartnermaster",
      ledger_id: parseInt(partnerData.LedgerID),
      bank_ledger_id: parseInt(this.state.selectedBankLedgerId),
      department: finalDept,
    };

    this.setState({ isProcessing: true });

    try {
      await this.props.createChannelPrtnerPayout(JSON.stringify(payload));
      this.setState({
        isProcessing: false,
        showPayoutModal: false,
        message: "Payout Initiated Successfully!",
        messageAlert: true,
      });

      this.props.getAccountLedgerbyid(
        JSON.stringify({ LedgerID: partnerData.LedgerID }),
      );
    } catch (error) {
      this.setState({
        isProcessing: false,
        message: "Payout Failed!",
        messageAlert: true,
      });
    }
  };
  handleAmountChange = (e) => {
    const enteredVal = parseFloat(e.target.value) || 0;

    if (enteredVal > this.state.maxPayoutAmount) {
      this.setState({
        payoutAmount: this.state.maxPayoutAmount,
        message: `You cannot pay more than the calculated amount of INR ${this.state.maxPayoutAmount}`,
        messageAlert: true,
      });
    } else {
      this.setState({ payoutAmount: enteredVal });
    }
  };
  recoverData = (idFromLocalStorage) => {
    const partnerList = Array.isArray(this.props.channelPartnerList)
      ? this.props.channelPartnerList
      : this.props.channelPartnerList?.data || [];

    const selectedId =
      idFromLocalStorage || localStorage.getItem("selectedPartnerId");
    const loggedInRole = localStorage.getItem("StaffRole");
    const loggedInUsername = localStorage.getItem("username");
    let partner = null;
    if (selectedId) {
      partner = partnerList.find(
        (p) => String(p.partner_id) === String(selectedId),
      );
    }
    if (!partner && loggedInRole === "CHANNEL PARTNER") {
      partner = partnerList.find(
        (p) => String(p.phone) === String(loggedInUsername),
      );
    }

    if (partner) {
      this.setState({ partnerData: partner, isLoading: false }, () => {
        this.fetchDependencyData(partner);
      });
    } else {
      if (partnerList.length > 0) {
        this.setState({ isLoading: false });
      }
    }
  };
  fetchDependencyData = (partner) => {
    const hospitalCode = localStorage.getItem("hospitalCode");
    const payload = JSON.stringify({
      partner_id: partner.partner_id.toString(),
      hid: hospitalCode,
    });

    this.props.getAccountPersonal(payload);
    this.props.getChannelPartnerDoc(payload);
    this.props.getChannelPartnerCommissionLog(payload);
    this.props.getChannelPartnerPayoutBalance(
      JSON.stringify({
        hid: hospitalCode,
        partner_id: partner.partner_id,
        partner_ledger_id: partner.LedgerID,
      }),
    );
  };
  handleCustomerClick = async (item) => {
    this.setState({
      selectedCustomer: item,
      customerDetailModal: true,
    });

    const currentHid = localStorage.getItem("hospitalCode")?.toString() || "0";
    const payload = JSON.stringify({
      AccountNameId: item.id.toString(),
      hid: currentHid,
    });

    try {
      await this.props.getSalesOrders(payload);
    } catch (error) {
      console.error("Error fetching customer invoices:", error);
    } finally {
      this.setState({ isLoadingInvoices: false });
    }
  };

  handleCommissionLogTabClick = () => {
    const { partnerData } = this.state;
    const currentHid = localStorage.getItem("hospitalCode")?.toString() || "0";
    if (partnerData) {
      this.props.getChannelPartnerCommissionLog(
        JSON.stringify({
          partner_id: partnerData.partner_id,
          hid: currentHid,
        }),
      );
    }
  };

  handleUpdateCommissionStatus = async (id, status) => {
    const { partnerData } = this.state;
    const currentHid = localStorage.getItem("hospitalCode")?.toString() || "0";
    this.setState({ isProcessing: true });

    try {
      const res = await this.props.updateChannelPartnerCommissionLog(
        JSON.stringify({
          id: id,
          status: status,
          hid: currentHid,
        }),
      );
      if (res && res.success) {
        this.setState({
          message: `Commission status updated to ${status} successfully!`,
          messageAlert: true,
          isProcessing: false,
        });
        this.props.getChannelPartnerCommissionLog(
          JSON.stringify({
            partner_id: partnerData.partner_id,
            hid: currentHid,
          }),
        );
        this.props.getChannelPartnerPayoutBalance(
          JSON.stringify({
            hid: currentHid,
            partner_id: partnerData.partner_id,
            partner_ledger_id: partnerData.LedgerID,
          }),
        );
      }
    } catch (error) {
      this.setState({ isProcessing: false });
      console.error("Status Update Failed", error);
    }
  };

  handleBillingTabClick = () => {
    const { partnerData } = this.state;
    const currentHid = localStorage.getItem("hospitalCode")?.toString() || "0";
    if (partnerData) {
      this.props.getChannelPartnerPayoutBalance(
        JSON.stringify({
          hid: currentHid,
          partner_id: partnerData.partner_id,
          partner_ledger_id: partnerData.LedgerID,
        }),
      );
      this.props.getChannelPrtnerPayout(
        JSON.stringify({
          hid: currentHid,
          partner_id: partnerData.partner_id,
        }),
      );
    }
  };
  toggleEmbedModal = () => {
    this.setState({ embedModal: !this.state.embedModal });
  };

  handleCopyEmbedCode = () => {
    const { partnerData } = this.state;
    const hid = localStorage.getItem("hospitalCode")?.toString() || "";

    const cleanPhone = (partnerData?.phone || "0000000000").replace(/\D/g, "");
    const cleanDob = (partnerData?.dob || "00000000").replace(/\D/g, "");

    const compositeId = `${hid}${cleanPhone}${cleanDob}`;

    const embedUrl = `${window.location.origin}/#/standalone/partner-products/${compositeId}`;
    const embedCode = `<iframe src="${embedUrl}" width="100%" height="600px" style="border:none;"></iframe>`;

    navigator.clipboard.writeText(embedCode).then(() => {
      this.setState({
        message: "Partner Product Widget code copied!",
        messageAlert: true,
        embedModal: false,
      });
    });
  };
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    if (this.loaderTimeout) clearTimeout(this.loaderTimeout);
  }

  getBadge = (status) => {
    return status === 1 || status === "1" ? "success" : "danger";
  };

  handleDelete = () => this.setState({ deleteModal: true });

  handleCountrySelect = (c) => {
    this.setState({
      country: c.name,
      countrySearch: c.name,
      selectedCountryShort: c.shortName,
      state: "",
      stateSearch: "",
      city: "",
      citySearch: "",
      provincesList: c.provinces || [],
      citiesList: [],
      showCountryDrop: false,
    });
  };
  handleClickOutside = (event) => {
    if (
      this.channelRef.current &&
      !this.channelRef.current.contains(event.target)
    ) {
      this.setState({ showChannelDrop: false });
    }
    if (
      this.countryRef.current &&
      !this.countryRef.current.contains(event.target)
    ) {
      this.setState({ showCountryDrop: false });
    }
    if (
      this.stateRef.current &&
      !this.stateRef.current.contains(event.target)
    ) {
      this.setState({ showStateDrop: false });
    }
    if (this.cityRef.current && !this.cityRef.current.contains(event.target)) {
      this.setState({ showCityDrop: false });
    }
    if (
      this.sourceRef.current &&
      !this.sourceRef.current.contains(event.target)
    ) {
      this.setState({ showSourceDrop: false });
    }
  };
  handleStateSelect = (p) => {
    const cities = this.state.selectedCountryShort
      ? getCities(this.state.selectedCountryShort, p)
      : [];
    this.setState({
      state: p,
      stateSearch: p,
      city: "",
      citySearch: "",
      citiesList: cities,
      showStateDrop: false,
    });
  };

  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({
        partner_photo: file,
        partner_photo_path: URL.createObjectURL(file),
      });
    }
  };

  setEditData = (item) => {
    const countryObj = processedCountriesData.find(
      (c) => c.name === item.country,
    );
    const states = countryObj ? countryObj.provinces : [];
    const cities =
      countryObj && item.state
        ? getCities(countryObj.shortName, item.state)
        : [];
    const mapping = (this.props.channelPartnerMappingList || []).find(
      (m) => String(m.partner_id) === String(item.partner_id),
    );

    const channelObj = (this.props.channelPartnerSetupList || []).find(
      (c) => String(c.id) === String(mapping?.sales_channel_id),
    );

    this.setState({
      modaladdproject: true,
      btn: "Update",
      partner_id: item.partner_id || "",
      partner_name: item.partner_name || "",
      dob: item.dob || "",
      last_name: item.last_name || "",
      email: item.email || "",
      phone: item.phone || "",
      address_line1: item.address_line1 || "",
      country: item.country || "",
      state: item.state && item.state !== "null" ? item.state : "",
      city: item.city && item.city !== "null" ? item.city : "",
      pincode: item.pincode || "",
      gst_number: item.gst_number || "",
      pan_number: item.pan_number || "",
      bank_name: item.bank_name || "",
      bank_account_no: item.bank_account_no || "",
      bank_ifsc: item.bank_ifsc || "",
      upi_id: item.upi_id || "",
      is_active: parseInt(item.is_active) || 0,
      selectedSources: item.sourceTypes
        ? Array.isArray(item.sourceTypes)
          ? item.sourceTypes.map((s) =>
              typeof s === "object" ? s.sourceType : s,
            )
          : typeof item.sourceTypes === "string"
            ? JSON.parse(item.sourceTypes)
            : []
        : [],
      sourceSearch: "",
      partner_photo:
        item.partner_photo && item.partner_photo !== "null"
          ? item.partner_photo
          : null,
      partner_photo_path:
        item.partner_photo && item.partner_photo !== "null"
          ? S3_BUCKET_URL + item.partner_photo
          : "",
      system_name: item.system_name || "",
      system_logo:
        item.system_logo && item.system_logo !== "null"
          ? item.system_logo
          : null,
      system_logo_path:
        item.system_logo && item.system_logo !== "null"
          ? S3_BUCKET_URL + item.system_logo
          : "",
      displaySystemLogo: !!item.system_logo && item.system_logo !== "null",
      security_deposit_amount:
        item.security_deposit_amount == 0 ||
        item.security_deposit_amount == "0.00"
          ? ""
          : item.security_deposit_amount,
      channel_id: mapping ? mapping.sales_channel_id : "",
      channelSearch: channelObj ? channelObj.channel_name : "",
      selectedChannelInfo: channelObj || null,
      mapping_id: mapping ? mapping.id : null,
      countrySearch: item.country || "",
      stateSearch: item.state || "",
      citySearch: item.city || "",
      provincesList: states,
      citiesList: cities,
      selectedCountryShort: countryObj ? countryObj.shortName : "IN",
      fileInputKey: Date.now(),
    });
  };
  handlePasswordUpdate = async () => {
    const { newPassword, partnerData } = this.state;
    const userList = Array.isArray(this.props.userGetData)
      ? this.props.userGetData
      : this.props.userGetData?.data || [];
    const userObj = userList.find(
      (u) => String(u.username) === String(partnerData?.phone),
    );

    if (!userObj) {
      this.setState({
        message: "Linked User account not found!",
        messageAlert: true,
      });
      return;
    }

    if (!newPassword || newPassword.trim() === "") {
      this.setState({
        message: "Please enter a new password",
        messageAlert: true,
      });
      return;
    }

    this.setState({ isProcessing: true });

    try {
      const formData = new FormData();
      formData.append("id", userObj.id);
      formData.append(
        "hospitalID",
        userObj.hospitalID || localStorage.getItem("hospitalCode"),
      );
      formData.append("password", newPassword);
      formData.append("username", userObj.username);
      formData.append("first_name", userObj.first_name);
      formData.append("role", userObj.role);
      formData.append("action", "1");

      await this.props.updateUser(formData);

      this.setState({
        resetModal: false,
        isEditingPassword: false,
        newPassword: "",
        message: "Password updated successfully!",
        messageAlert: true,
        isProcessing: false,
      });
      this.props.getUser(
        JSON.stringify({ hid: localStorage.getItem("hospitalCode") }),
      );
    } catch (error) {
      this.setState({
        isProcessing: false,
        message: "Failed to update password",
        messageAlert: true,
      });
    }
  };
  handleAccountAdminClick = (item) => {
    if (item.paymentStatus !== "Paid") {
      this.setState({
        message:
          "Not Paid Yet! Please complete the payment to access admin panel.",
        messageAlert: true,
      });
      return;
    }

    if (item.id) {
      localStorage.setItem("navSource", "partner");

      this.props.setSelectedAccountData(item);

      this.props.history.push({
        pathname: "/setup/Cpanel",
        state: {
          ...item,
          from: "partner",
        },
      });
    }
  };
  handleUpdatePartner = async () => {
    const currentHid = localStorage.getItem("hospitalCode")?.toString() || "0";
    const {
      partner_id,
      partner_name,
      last_name,
      email,
      phone,
      dob,
      address_line1,
      city,
      state,
      pincode,
      country,
      gst_number,
      pan_number,
      bank_name,
      bank_account_no,
      bank_ifsc,
      upi_id,
      is_active,
      partner_photo,
      partner_photo_path,
      system_name,
      system_logo,
      system_logo_path,
      security_deposit_amount,
      selectedChannelInfo,
      partnerData,
    } = this.state;

    if (!partner_name || !email || !phone || !this.state.channel_id) {
      this.setState({
        message:
          "Mandatory fields (Name, Email, Phone, Designation) are missing!",
        messageAlert: true,
      });
      return;
    }

    const isEmailChanged =
      email.trim().toLowerCase() !==
      (partnerData?.email || "").trim().toLowerCase();

    let newGeneratedPassword = "";
    if (isEmailChanged) {
      newGeneratedPassword = generateRandomPassword();
    }

    const userList = Array.isArray(this.props.userGetData)
      ? this.props.userGetData
      : this.props.userGetData?.data || [];

    const existingUser = userList.find(
      (u) =>
        String(u.partytype) === "PARTNER" &&
        String(u.partytypeId) === String(partner_id),
    );

    this.setState({
      isProcessing: true,
      message: isEmailChanged
        ? "Updating & Sending Mail..."
        : "Updating Profile...",
    });

    try {
      const formData = new FormData();
      formData.append("partner_id", partner_id);
      formData.append("hid", currentHid);
      formData.append("partner_name", partner_name);
      formData.append("last_name", last_name || "");
      formData.append("dob", dob || "");
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("address_line1", address_line1 || "");
      formData.append("city", city || "");
      formData.append("state", state || "");
      formData.append("pincode", pincode || "");
      formData.append("country", country || "India");
      formData.append("gst_number", gst_number || "");
      formData.append("pan_number", pan_number || "");
      formData.append("bank_name", bank_name || "");
      formData.append(
        "bank_account_no",
        bank_account_no ? bank_account_no.toString().replace(/\s/g, "") : "",
      );
      formData.append("bank_ifsc", bank_ifsc || "");
      formData.append("upi_id", upi_id || "");
      formData.append("is_active", is_active);
      formData.append("system_name", system_name || "");
      formData.append("security_deposit_amount", security_deposit_amount || 0);
      formData.append("department", "INTL SALES");
      formData.append(
        "sourceTypes",
        JSON.stringify(this.state.selectedSources),
      );

      if (system_logo instanceof File) {
        formData.append("system_logo", system_logo);
      } else {
        let currentLogo =
          system_logo || (partnerData ? partnerData.system_logo : "") || "";
        if (currentLogo === "null" || currentLogo === null) currentLogo = "";
        formData.append("system_logo", currentLogo.replace(S3_BUCKET_URL, ""));
      }

      if (partner_photo instanceof File) {
        formData.append("partner_photo", partner_photo);
      } else {
        let currentPhoto =
          partner_photo || (partnerData ? partnerData.partner_photo : "") || "";
        if (currentPhoto === "null" || currentPhoto === null) currentPhoto = "";
        formData.append(
          "partner_photo",
          currentPhoto.replace(S3_BUCKET_URL, ""),
        );
      }
      await this.props.updateChanelPartner(formData);
      if (existingUser) {
        const userFormData = new FormData();
        const finalDesignation = selectedChannelInfo
          ? selectedChannelInfo.channel_name.toUpperCase()
          : existingUser.designation;

        userFormData.append("id", existingUser.id);
        userFormData.append("hospitalID", currentHid);
        userFormData.append("first_name", partner_name);
        userFormData.append("last_name", last_name || "");
        userFormData.append("email", email);
        userFormData.append("mobile", phone);
        userFormData.append("username", phone);
        userFormData.append("dob", dob || "");
        userFormData.append("role", "CHANNEL PARTNER");
        userFormData.append("department", "INTL SALES");
        userFormData.append("designation", finalDesignation);
        userFormData.append("action", "1");
        userFormData.append("app_status", is_active == 1 ? "1" : "0");
        userFormData.append("partytype", "PARTNER");
        userFormData.append("partytypeId", partner_id);

        if (isEmailChanged) {
          userFormData.append("password", newGeneratedPassword);
        }

        if (partner_photo instanceof File) {
          userFormData.append("profileimage", partner_photo);
        } else {
          let currentImg = partner_photo || existingUser.profileimage || "";
          if (currentImg === "null" || currentImg === null) currentImg = "";
          userFormData.append(
            "profileimage",
            currentImg.replace(S3_BUCKET_URL, ""),
          );
        }
        await this.props.updateUser(userFormData);
      }
      if (isEmailChanged && newGeneratedPassword !== "") {
        const mailPayload = {
          hid: currentHid,
          eventName: "MEDISEVAS_EMAIL_USERPASS",
          recipientEmail: email,
          templateData: {
            HospitalName: "MediSevas",
            UserName: partner_name,
            UserEmail: phone,
            Password: newGeneratedPassword,
            LoginURL: "www.medisevas.com",
          },
        };
        await this.props.sendMail(mailPayload);
      }
      const timestamp = new Date().getTime();
      const updatedPartnerObject = {
        ...partnerData,
        partner_name,
        last_name,
        email,
        phone,
        dob,
        address_line1,
        city,
        state,
        pincode,
        country,
        gst_number,
        pan_number,
        bank_name,
        bank_account_no,
        bank_ifsc,
        upi_id,
        is_active,
        system_name,
        security_deposit_amount: security_deposit_amount
          ? parseFloat(security_deposit_amount).toString()
          : "0",
        sourceTypes: this.state.selectedSources.map((s) => ({ sourceType: s })),
        partner_photo:
          partner_photo instanceof File
            ? `${partner_photo_path}?t=${timestamp}`
            : partner_photo
              ? `${partner_photo.startsWith("http") ? partner_photo : S3_BUCKET_URL + partner_photo}?t=${timestamp}`
              : null,
        system_logo:
          system_logo instanceof File
            ? `${system_logo_path}?t=${timestamp}`
            : system_logo
              ? `${system_logo.startsWith("http") ? system_logo : S3_BUCKET_URL + system_logo}?t=${timestamp}`
              : null,
      };
      await this.props.getChanelPartner(JSON.stringify({ hid: currentHid }));
      await this.props.getUser(JSON.stringify({ hid: currentHid }));

      this.setState({
        isProcessing: false,
        modaladdproject: false,
        partnerData: updatedPartnerObject,
        message: isEmailChanged
          ? "Profile Updated & New Credentials Sent to Email!"
          : "Partner Profile Updated Successfully!",
        messageAlert: true,
      });
    } catch (error) {
      console.error("Critical Update Error:", error);
      this.setState({
        isProcessing: false,
        message: "Update Failed! Please check your connection.",
        messageAlert: true,
      });
    }
  };

  openCommissionEdit = (mapping) => {
    this.setState({
      commissionModal: true,
      mapping_id: mapping.id,
      partner_id: mapping.partner_id,
      override_calc_type:
        mapping.override_commission_calc_type ||
        mapping.commission_calc_type ||
        "",
      override_value:
        mapping.override_commission_value || mapping.commission_value || "",
      mapping_is_active: parseInt(mapping.is_active),
    });
  };

  handleSaveCommission = async () => {
    const hid = localStorage.getItem("hospitalCode")?.toString();
    if (!hid) return;

    const {
      mapping_id,
      partner_id,
      override_calc_type,
      override_value,
      mapping_is_active,
    } = this.state;
    if (override_value === "" || override_value === undefined) {
      this.setState({
        message: "Please enter an override value!",
        messageAlert: true,
      });
      return;
    }

    this.setState({ isProcessing: true });

    const payload = {
      id: mapping_id,
      partner_id: partner_id,
      override_commission_calc_type: override_calc_type,
      override_commission_value: override_value,
      hid: hid,
      is_active: mapping_is_active,
    };

    try {
      await this.props.updateChanelPartnerMapping(JSON.stringify(payload));
      const HospitalId = JSON.stringify({ hid: hid });
      await this.props.getChanelPartnerMapping(HospitalId);

      this.setState({
        isProcessing: false,
        commissionModal: false,
        message: "Commission updated successfully!",
        messageAlert: true,
      });
    } catch (error) {
      console.error("Error updating commission:", error);
      this.setState({
        isProcessing: false,
        message: "Failed to update commission!",
        messageAlert: true,
      });
    }
  };

  handleCountryChange = (countryName) => {
    const countryObj = processedCountriesData.find(
      (c) => c.name === countryName,
    );
    this.setState({
      country: countryName,
      provincesList: countryObj ? countryObj.provinces : [],
      state: "",
      citiesList: [],
      city: "",
    });
  };

  handleStateChange = (stateName) => {
    const countryObj = processedCountriesData.find(
      (c) => c.name === this.state.country,
    );
    const cities = countryObj ? getCities(countryObj.shortName, stateName) : [];
    this.setState({ state: stateName, citiesList: cities, city: "" });
  };
  confirmDelete = async () => {
    const hid = localStorage.getItem("hospitalCode").toString();
    await this.props.deleteChanelPartner({
      hid: hid,
      partner_id: this.state.partnerData.partner_id,
    });
    this.props.history.push("../Organization/ChannelPartner");
  };
  getExportData = () => {
    const rawList = this.props.accountpersonalList;
    const accountList = Array.isArray(rawList) ? rawList : rawList?.data || [];

    const myCustomers = accountList.filter((acc) => {
      return (
        String(acc.partner_id) === String(this.state.partnerData?.partner_id)
      );
    });

    return myCustomers.map((item) => ({
      "Customer ID": item.id || "N/A",
      "Customer Name": `${item.FirstName} ${item.LastName || ""}`,
      Phone: item.PhoneNumber || "N/A",
      Email: item.Email || "N/A",
      Product: item.ProductName || "N/A",
      Status: item.paymentStatus || "Pending",
    }));
  };

  exportToCSV = () => {
    const data = this.getExportData();
    const ws = XLSX.utils.json_to_sheet(data);
    const csvData = XLSX.utils.sheet_to_csv(ws);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(blob, "ChannelPartnerList.csv");
    this.setState({
      message: "CSV file downloaded successfully!",
      messageAlert: true,
    });
  };
  exportToExcel = () => {
    const data = this.getExportData();
    if (!data || data.length === 0) {
      this.setState({
        message: "No Data Available to Export!",
        messageAlert: true,
      });
      return;
    }

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = {
      Sheets: { data: ws },
      SheetNames: ["data"],
    };

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const finalData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    FileSaver.saveAs(finalData, "Customer_Report.xlsx");

    this.setState({
      message: "Excel downloaded successfully!",
      messageAlert: true,
    });
  };
  exportToPDF = () => {
    const data = this.getExportData();
    const doc = new jsPDF();
    doc.text("Channel Partner List", 14, 15);
    doc.autoTable({
      startY: 20,
      head: [["ID", "Customer Name", "Phone", "Product", "Status"]],
      body: data.map(Object.values),
    });
    doc.save("ChannelPartnerList.pdf");
    this.setState({
      message: "PDF file downloaded successfully!",
      messageAlert: true,
    });
  };
  downloadBillingPDF = (partnerSales, totalComm) => {
    const { partnerData } = this.state;
    const doc = new jsPDF("l", "mm", "a4");

    doc.setFontSize(18);
    doc.setTextColor(48, 60, 84);
    doc.text("COMMISSION STATEMENT / BILLING REPORT", 14, 15);

    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(
      `Report Generated Date: ${new Date().toLocaleDateString()}`,
      14,
      22,
    );

    doc.setDrawColor(200);
    doc.line(14, 25, 280, 25);

    doc.setFontSize(12);
    doc.setTextColor(0);
    doc.text("PARTNER INFORMATION", 14, 32);
    doc.setFontSize(10);
    doc.text(`Name: ${partnerData?.partner_name}`, 14, 38);
    doc.text(`Email: ${partnerData?.email}`, 14, 43);
    doc.text(`Phone: ${partnerData?.phone}`, 14, 48);
    doc.text(
      `Address: ${partnerData?.address_line1}, ${partnerData?.city}`,
      14,
      53,
    );

    doc.setFontSize(12);
    doc.text("BANK DETAILS FOR DISBURSEMENT", 150, 32);
    doc.setFontSize(10);
    doc.text(`Bank Name: ${partnerData?.bank_name || "N/A"}`, 150, 38);
    doc.text(`Account No: ${partnerData?.bank_account_no || "N/A"}`, 150, 43);
    doc.text(`IFSC Code: ${partnerData?.bank_ifsc || "N/A"}`, 150, 48);
    doc.text(
      `PAN/GST: ${partnerData?.pan_number || "N/A"} / ${partnerData?.gst_number || "N/A"}`,
      150,
      53,
    );

    const tableRows = partnerSales.map((item) => [
      item.salesorderId,
      item.AccountName,
      item.customerEmail || "N/A",
      item.ProductName,
      `INR ${parseFloat(item.GrandTotal).toFixed(2)}`,
      `${item.rateApplied}%`,
      `INR ${item.commissionAmount}`,
      item.Status,
    ]);

    doc.autoTable({
      startY: 60,
      head: [
        [
          "Order ID",
          "Customer Name",
          "Customer Email",
          "Product",
          "Order Total",
          "Comm. %",
          "Comm. Earned",
          "Status",
        ],
      ],
      body: tableRows,
      theme: "striped",
      headStyles: { fillColor: [48, 60, 84] },
      styles: { fontSize: 9 },
    });

    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text(
      `TOTAL COMMISSION PAYABLE: INR ${totalComm.toFixed(2)}`,
      200,
      finalY,
    );

    doc.save(
      `Billing_Report_${partnerData?.partner_name}_${partnerData?.partner_id}.pdf`,
    );

    this.setState({ message: "Billing PDF Downloaded!", messageAlert: true });
  };
  copyToClipboard = () => {
    const data = this.getExportData();
    const header = ["ID", "Customer Name", "Phone", "Product", "Status"];
    const rows = data.map((item) => Object.values(item).join("\t"));
    const fullContent = [header.join("\t"), ...rows].join("\n");

    const el = document.createElement("textarea");
    el.value = fullContent;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    this.setState({ message: "Data copied to clipboard!", messageAlert: true });
  };

  handlePrint = () => {
    const myCustomers = (this.props.accountpersonalList || []).filter((acc) => {
      return (
        String(acc.partner_id) === String(this.state.partnerData?.partner_id)
      );
    });

    const data = myCustomers.map((item) => ({
      ID: item.id || "N/A",
      "Customer Name": `${item.FirstName} ${item.LastName || ""}`,
      Phone: item.PhoneNumber || "N/A",
      Product: item.ProductName || "N/A",
      Status: item.paymentStatus || "Pending",
    }));

    if (data.length === 0) {
      alert("No data to print");
      return;
    }

    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write("<html><head><title>Print Report</title>");
    printWindow.document.write(
      "<style>table{border-collapse:collapse;width:100%;font-family:sans-serif;} td,th{border:1px solid #ddd;padding:8px;text-align:left;font-size:12px;} th{background-color:#303c54;color:white;}</style>",
    );
    printWindow.document.write("</head><body>");
    printWindow.document.write(
      "<h2>Customer List - " + this.state.partnerData?.partner_name + "</h2>",
    );
    printWindow.document.write(
      "<table><thead><tr><th>ID</th><th>Customer Name</th><th>Phone</th><th>Product</th><th>Status</th></tr></thead><tbody>",
    );

    data.forEach((item) => {
      printWindow.document.write(`<tr>
      <td>${item.ID}</td>
      <td>${item["Customer Name"]}</td>
      <td>${item.Phone}</td>
      <td>${item.Product}</td>
      <td>${item.Status}</td>
    </tr>`);
    });

    printWindow.document.write("</tbody></table></body></html>");
    printWindow.document.close();
    printWindow.print();
  };
  renderCustomerDetailModal = () => {
    const { selectedCustomer } = this.state;
    const customerInvoices = (this.props.salesordersList || [])
      .filter(
        (order) => String(order.AccountNameId) === String(selectedCustomer?.id),
      )
      .map((order) => {
        const customerAccount = (this.props.accountpersonalList || []).find(
          (acc) => String(acc.id) === String(order.AccountNameId),
        );

        return {
          ...order,
          customerImg: customerAccount?.ProfilePhoto,
          customerEmail: customerAccount?.Email,
          customerPhone: customerAccount?.PhoneNumber,
        };
      });

    return (
      <CModal
        show={this.state.customerDetailModal}
        onClose={() => this.setState({ customerDetailModal: false })}
        size="lg"
        backdrop={false}
        closeOnBackdrop={false}
      >
        <CModalHeader style={{ backgroundColor: "#303c54", color: "white" }}>
          <CRow
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 10px",
            }}
          >
            <CModalTitle>Customer Invoices</CModalTitle>

            <CButton
              onClick={() => this.setState({ customerDetailModal: false })}
            >
              <img src={closeKeImg} alt="close" width="20" height="20" />
            </CButton>
          </CRow>
        </CModalHeader>
        <CModalBody>
          {selectedCustomer && (
            <CRow>
              <CCol md="12">
                <h5 className="text-dark font-weight-bold mb-3">
                  Invoices for {selectedCustomer.FirstName}{" "}
                  {selectedCustomer.LastName}
                </h5>
                <CDataTable
                  items={customerInvoices}
                  fields={[
                    {
                      key: "salesorderId",
                      label: "Order ID",
                      _style: { width: "15%" },
                    },
                    {
                      key: "Customer",
                      label: "Customer Details",
                      _style: { width: "35%" },
                    },
                    {
                      key: "ProductName",
                      label: "Product",
                      _style: { width: "20%" },
                    },
                    {
                      key: "GrandTotal",
                      label: "Price (INR)",
                      _style: { width: "15%" },
                    },
                    {
                      key: "Status",
                      label: "Status",
                      _style: { width: "15%" },
                    },
                  ]}
                  hover
                  striped
                  bordered
                  size="sm"
                  itemsPerPage={5}
                  pagination
                  scopedSlots={{
                    Customer: (item) => (
                      <td className="align-middle">
                        <div className="d-flex align-items-center">
                          <img
                            src={
                              item.customerImg
                                ? S3_BUCKET_URL + item.customerImg
                                : user
                            }
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              marginRight: "12px",
                              border: "1px solid #dee2e6",
                            }}
                            onError={(e) => {
                              e.target.src = user;
                            }}
                          />
                          <div>
                            <div
                              className="font-weight-bold text-primary"
                              style={{ lineHeight: "1.2" }}
                            >
                              {item.AccountName}
                            </div>
                            <div className="small text-muted">
                              {item.customerEmail || "No Email"}
                            </div>
                            <div
                              className="small text-muted"
                              style={{ fontSize: "10px" }}
                            >
                              {item.customerPhone || "No Phone"}
                            </div>
                          </div>
                        </div>
                      </td>
                    ),
                    GrandTotal: (item) => (
                      <td className="align-middle">
                        <span className="font-weight-bold">
                          ₹{parseFloat(item.GrandTotal).toLocaleString()}
                        </span>
                      </td>
                    ),
                    Status: (item) => (
                      <td className="align-middle">
                        <CBadge
                          color={item.Status === "Paid" ? "success" : "warning"}
                        >
                          {item.Status}
                        </CBadge>
                      </td>
                    ),
                  }}
                />
              </CCol>
            </CRow>
          )}
        </CModalBody>
      </CModal>
    );
  };
  formatCurrency = (amountInINR) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amountInINR);
  };

  renderProductCard = (product) => {
    return (
      <CCol lg="4" md="6" sm="12" className="mb-4" key={product.id}>
        <CCard
          className="h-100 shadow-sm border-0"
          style={{ borderRadius: "15px", overflow: "hidden" }}
        >
          <CCardBody className="d-flex flex-column p-4">
            <h4 className="font-weight-bold text-dark mb-3">{product.Name}</h4>
            <div className="mb-3">
              <span className="h3 text-primary font-weight-bold">
                {this.formatCurrency(product.FinalAmount)}
              </span>
              <small className="text-muted"> / month</small>
            </div>
            <p
              className="text-muted mb-4"
              style={{ fontSize: "0.9rem", flexGrow: 1 }}
            >
              {product.Description}
            </p>
            <CButton
              color="info"
              className="text-white font-weight-bold py-2"
              style={{ borderRadius: "10px" }}
            >
              Buy Now
            </CButton>
          </CCardBody>
        </CCard>
      </CCol>
    );
  };
  handleDurationChange(productId, duration) {
    this.setState((prevState) => ({
      selectedDurations: {
        ...prevState.selectedDurations,
        [productId]: duration,
      },
    }));
  }

  toggleFeature(id) {
    this.setState((prev) => ({
      selectedFeatureId: prev.selectedFeatureId === id ? null : id,
    }));
  }

  formatCurrency(amountInINR, currency = "INR") {
    if (amountInINR == null || isNaN(amountInINR)) return "";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: currency,
      maximumFractionDigits: 0,
    }).format(amountInINR);
  }
  render() {
    const loggedInRole = localStorage.getItem("StaffRole");
    const isChannelPartner = loggedInRole === "CHANNEL PARTNER";
    const { partnerData, isLoading } = this.state;
    const { channelPartnerSetupList, channelPartnerMappingList } = this.props;
    const isWidgetMode =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.hid;

    if (isWidgetMode) {
      const compositeId = this.props.match.params.hid;

      const standalonePartner = (this.props.channelPartnerList || []).find(
        (p) => {
          const cleanPhone = (p.phone || "").replace(/\D/g, "");
          const cleanDob = (p.dob || "").replace(/\D/g, "");
          return compositeId.endsWith(cleanPhone + cleanDob);
        },
      );

      const standaloneMapping = (
        this.props.channelPartnerMappingList || []
      ).find(
        (m) => String(m.partner_id) === String(standalonePartner?.partner_id),
      );
      const standaloneMappedIds = (
        standaloneMapping?.product_mapping || []
      ).map((p) => String(p.product_id));

      const standaloneProducts = (
        this.props.productList?.data ||
        this.props.productList ||
        []
      ).filter((p) => standaloneMappedIds.includes(String(p.id)));

      return (
        <div className="landing-page-wrapper bg-light">
          <div className="container py-5">
            <div className="row">
              {standaloneProducts.map((product) => {
                const discountOptions = product.discounts || [];
                const currentSelected =
                  this.state.selectedDurations[product.id] ||
                  (discountOptions[0] ? discountOptions[0].duration : "");

                const selectedDiscountObj = discountOptions.find(
                  (opt) => opt.duration === currentSelected,
                );
                const discountPercent = selectedDiscountObj
                  ? parseFloat(selectedDiscountObj.discount)
                  : 0;
                const baseAmount = parseFloat(product.FinalAmount) || 0;
                const discountedPrice =
                  baseAmount - baseAmount * (discountPercent / 100);
                const isCollapseOpen =
                  this.state.selectedFeatureId === product.id;

                return (
                  <div className="col-lg-4 mb-4" key={product.id}>
                    <div
                      className="pricing-card h-100 d-flex flex-column shadow-sm bg-white p-4"
                      style={{ borderRadius: "15px", border: "1px solid #eee" }}
                    >
                      <h3 className="h4 font-weight-bold">{product.Name}</h3>

                      <div className="price my-3">
                        <span className="h2 text-primary font-weight-bold">
                          {this.formatCurrency(discountedPrice)}
                        </span>
                        <span className="text-muted"> / month</span>
                      </div>

                      {discountPercent > 0 && (
                        <div className="mb-2">
                          <small className="text-muted">
                            <del>{this.formatCurrency(baseAmount)}</del>
                          </small>
                          <small className="text-success fw-bold ml-2">
                            {discountPercent}% Off
                          </small>
                        </div>
                      )}

                      <div className="mb-3">
                        <CSelect
                          custom
                          value={currentSelected}
                          onChange={(e) =>
                            this.handleDurationChange(
                              product.id,
                              e.target.value,
                            )
                          }
                        >
                          {discountOptions.map((opt) => (
                            <option key={opt.id} value={opt.duration}>
                              {opt.duration}{" "}
                              {parseFloat(opt.discount) > 0
                                ? `(${opt.discount}%)`
                                : ""}
                            </option>
                          ))}
                        </CSelect>
                      </div>

                      <p className="text-muted small mb-4">
                        {product.Description}
                      </p>

                      <div className="mt-auto">
                        <button
                          className="btn btn-primary w-100 mb-3"
                          onClick={() =>
                            this.props.history.push(
                              `/homesignup?productId=${product.id}&duration=${currentSelected}`,
                            )
                          }
                        >
                          Buy Now <i className="cil-arrow-right"></i>
                        </button>

                        <button
                          className="btn btn-link p-0 text-decoration-none small"
                          onClick={() => this.toggleFeature(product.id)}
                        >
                          {isCollapseOpen ? "- Hide Details" : "+ More Details"}
                        </button>

                        <div
                          className={`collapse ${isCollapseOpen ? "show" : ""} mt-3 pt-2 border-top`}
                        >
                          <ul className="list-unstyled">
                            {product.specifications &&
                              product.specifications.map((spec) => (
                                <li key={spec.id} className="small mb-1">
                                  <CIcon
                                    name="cil-check-circle"
                                    className="text-success mr-2"
                                    size="sm"
                                  />
                                  {spec.name}
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    }

    const commissionMapping = (this.props.channelPartnerMappingList || []).find(
      (m) =>
        String(m.partner_id) === String(partnerData?.partner_id) &&
        m.is_active == 1,
    );
    const commRate = parseFloat(
      commissionMapping?.override_commission_value || 0,
    );

    const partnerSales = (this.props.salesordersList || [])
      .filter(
        (order) => String(order.partner_id) === String(partnerData?.partner_id),
      )
      .map((order) => {
        const customerAccount = (this.props.accountpersonalList || []).find(
          (acc) => String(acc.id) === String(order.AccountNameId),
        );

        const totalAmount = parseFloat(order.GrandTotal || 0);
        const calculatedComm = (totalAmount * commRate) / 100;

        return {
          ...order,
          customerImg: customerAccount?.ProfilePhoto,
          customerEmail: customerAccount?.Email,
          customerPhone: customerAccount?.PhoneNumber,
          commissionAmount: calculatedComm.toFixed(2),
          rateApplied: commRate,
        };
      });

    const totalPayableCommission = partnerSales.reduce(
      (sum, item) => sum + parseFloat(item.commissionAmount),
      0,
    );

    const uniqueCommissionTypes = Array.from(
      new Set(
        (channelPartnerSetupList || [])
          .filter((setup) => setup.commission_calc_type)
          .map((setup) => setup.commission_calc_type),
      ),
    );

    const filteredChannels = (channelPartnerSetupList || []).filter(
      (c) =>
        c.channel_name &&
        c.channel_name
          .toLowerCase()
          .includes((this.state.channelSearch || "").toLowerCase()),
    );

    const filteredCountries = (processedCountriesData || []).filter(
      (c) =>
        c.name &&
        c.name
          .toLowerCase()
          .includes((this.state.countrySearch || "").toLowerCase()),
    );

    const filteredStates = (this.state.provincesList || []).filter(
      (p) =>
        p &&
        p.toLowerCase().includes((this.state.stateSearch || "").toLowerCase()),
    );

    const filteredCities = (this.state.citiesList || []).filter(
      (city) =>
        city &&
        city
          .toLowerCase()
          .includes((this.state.citySearch || "").toLowerCase()),
    );

    const userData = (this.props.userGetData || []).find(
      (u) => u.username === partnerData?.phone,
    );

    const partnerListForCheck = Array.isArray(this.props.channelPartnerList)
      ? this.props.channelPartnerList
      : this.props.channelPartnerList?.data || [];
    if (isLoading) {
      return (
        <div className="p-5 text-center" style={{ marginTop: "100px" }}>
          <GlobalLoader isLoading={true} />
          <h3 className="mt-3">Loading Profile Details...</h3>
        </div>
      );
    }
    if (!partnerData && !isLoading) {
      return (
        <div className="p-5 text-center">
          <h3>Partner Profile Not Found</h3>
          <p>We couldn't link your login to a partner profile.</p>
          <CButton
            color="primary"
            onClick={() => this.props.history.push("/dashboard")}
          >
            Go to Dashboard
          </CButton>
        </div>
      );
    }

    if (!partnerData && (isLoading || partnerListForCheck.length > 0)) {
      return (
        <div className="p-5 text-center" style={{ marginTop: "100px" }}>
          <GlobalLoader isLoading={true} />
          <h3 className="mt-3">Loading Profile Details...</h3>
          <p className="text-muted">
            Please wait while we sync your partner data.
          </p>
        </div>
      );
    }

    if (!partnerData && !isLoading && partnerListForCheck.length === 0) {
      return (
        <div className="p-5 text-center">
          <h3>Partner Profile Not Found</h3>
          <CButton
            color="primary"
            onClick={() =>
              this.props.history.push("../Organization/ChannelPartner")
            }
          >
            Back to Partner List
          </CButton>
        </div>
      );
    }
    const currentPartnerMapping = (channelPartnerMappingList || []).filter(
      (m) => String(m.partner_id) === String(partnerData?.partner_id),
    );

    const rawAccountList = this.props.accountpersonalList;
    const accountList = Array.isArray(rawAccountList)
      ? rawAccountList
      : rawAccountList?.data || [];

    const myCustomers = accountList.filter((acc) => {
      const isMyCustomer =
        String(acc.partner_id) === String(partnerData?.partner_id);
      const search = this.state.customerSearchText.toLowerCase();
      const fullName = `${acc.FirstName} ${acc.LastName}`.toLowerCase();
      const matchesSearch =
        fullName.includes(search) ||
        (acc.PhoneNumber && acc.PhoneNumber.includes(search));
      return isMyCustomer && matchesSearch;
    });
    const currentMapping = (this.props.channelPartnerMappingList || []).find(
      (m) => String(m.partner_id) === String(partnerData?.partner_id),
    );

    const mappedProductIds = (currentMapping?.product_mapping || []).map((p) =>
      String(p.product_id),
    );

    const partnerSpecificProducts = (
      this.props.productList?.data ||
      this.props.productList ||
      []
    ).filter((prod) => mappedProductIds.includes(String(prod.id)));

    return (
      <>
        <GlobalLoader isLoading={isLoading} />

        <CModal
          show={this.state.resetModal}
          onClose={() =>
            this.setState({ resetModal: false, isEditingPassword: false })
          }
          size="sm"
          backdrop={false}
          closeOnBackdrop={false}
        >
          <CModalHeader style={{ backgroundColor: "#303c54", color: "white" }}>
            <CModalTitle style={{ fontSize: "16px" }}>
              User Security
            </CModalTitle>
            <CButton
              onClick={() =>
                this.setState({ resetModal: false, isEditingPassword: false })
              }
            >
              <img
                src={closeKeImg}
                alt=""
                width="18"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </CButton>
          </CModalHeader>
          <CModalBody>
            <CFormGroup>
              <CLabel className="font-weight-bold small">
                Current Password
              </CLabel>
              <CInput
                type="password"
                value="xxxxxxxxxxxxxxxx"
                disabled
                className="bg-light"
              />
              <small className="text-muted">
                Password is encrypted for security.
              </small>
            </CFormGroup>

            {this.state.isEditingPassword ? (
              <CFormGroup className="mt-3">
                <CLabel className="font-weight-bold small text-primary">
                  Enter New Password
                </CLabel>
                <CInput
                  type="text"
                  placeholder="e.g. Partner@123"
                  value={this.state.newPassword}
                  onChange={(e) =>
                    this.setState({ newPassword: e.target.value })
                  }
                />
              </CFormGroup>
            ) : (
              <div className="text-center mt-3">
                <CButton
                  color="info"
                  size="sm"
                  block
                  onClick={() => this.setState({ isEditingPassword: true })}
                >
                  <FaPen className="mr-2" /> Change Password
                </CButton>
              </div>
            )}
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              size="sm"
              onClick={() =>
                this.setState({ resetModal: false, isEditingPassword: false })
              }
            >
              Cancel
            </CButton>
            {this.state.isEditingPassword && (
              <CButton
                color="success"
                size="sm"
                onClick={this.handlePasswordUpdate}
                disabled={this.state.isProcessing}
              >
                {this.state.isProcessing ? "Updating..." : "Update Now"}
              </CButton>
            )}
          </CModalFooter>
        </CModal>
        <CModal
          show={this.state.showPayoutModal}
          onClose={() => this.setState({ showPayoutModal: false })}
          size="lg"
          backdrop={false}
          closeOnBackdrop={false}
        >
          <CModalHeader style={{ backgroundColor: "#303c54", color: "white" }}>
            <CModalTitle>Initiate Commission Payout</CModalTitle>
            <CButton onClick={() => this.setState({ showPayoutModal: false })}>
              <img src={closeKeImg} alt="" width="20" height="20" />
            </CButton>
          </CModalHeader>

          <CModalBody className="bg-light text-dark">
            {" "}
            <CCard className="mb-3 border-0 shadow-sm">
              <CCardBody className="text-dark">
                <CRow>
                  <CCol md="6">
                    <h6 className="text-muted font-weight-bold">
                      Beneficiary Information
                    </h6>
                    <p className="mb-1">
                      <strong>Frist Name:</strong> {partnerData?.partner_name}
                    </p>
                    <p className="mb-1">
                      <strong>Bank Name:</strong> {partnerData?.bank_name}
                    </p>
                    <p className="mb-1">
                      <strong>Account No:</strong>{" "}
                      {partnerData?.bank_account_no}
                    </p>
                    <p className="mb-1">
                      <strong>IFSC Code:</strong> {partnerData?.bank_ifsc}
                    </p>
                  </CCol>
                  <CCol md="6" className="text-right">
                    <h6 className="text-muted font-weight-bold">
                      Total Outstanding
                    </h6>
                    <h3 className="text-primary font-weight-bold">
                      INR {this.state.payoutAmount}
                    </h3>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CRow>
              <CCol md="6">
                <CFormGroup>
                  <CLabel className="text-dark font-weight-bold">
                    Source Bank Account (Hospital)
                  </CLabel>
                  <CSelect
                    className="text-dark border-secondary"
                    value={this.state.selectedBankLedgerId}
                    onChange={(e) =>
                      this.setState({ selectedBankLedgerId: e.target.value })
                    }
                  >
                    <option value="">-- Select Source Bank --</option>
                    {this.props.AccountMainBankMasterList?.map((bank) => (
                      <option key={bank.BankID} value={bank.LedgerID}>
                        {bank.BankName} - {bank.BankAccountNo}
                      </option>
                    ))}
                  </CSelect>
                </CFormGroup>
              </CCol>

              <CCol md="6">
                <CFormGroup>
                  <CLabel className="text-dark font-weight-bold">
                    Payment Gateway
                  </CLabel>
                  <CSelect
                    className="text-dark border-secondary"
                    value={this.state.selectedGateway}
                    onChange={(e) =>
                      this.setState({ selectedGateway: e.target.value })
                    }
                  >
                    <option value="">-- Select Gateway --</option>
                    {(() => {
                      const list =
                        this.props.paymentGetwayList?.data ||
                        this.props.paymentGetwayList;

                      if (Array.isArray(list)) {
                        return list.map((gw, index) => (
                          <option key={index} value={gw}>
                            {typeof gw === "string"
                              ? gw.toUpperCase()
                              : gw.gateway_name || "GATEWAY"}
                          </option>
                        ));
                      }
                      return null;
                    })()}
                  </CSelect>
                </CFormGroup>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <CFormGroup>
                  <CLabel className="text-dark font-weight-bold">
                    Disbursement Amount (Max: {this.state.maxPayoutAmount})
                  </CLabel>
                  <CInput
                    type="number"
                    className="text-dark border-secondary font-weight-bold"
                    style={{ fontSize: "1.2rem", color: "#28a745" }}
                    value={this.state.payoutAmount}
                    onChange={this.handleAmountChange}
                  />
                  <small className="text-muted">
                    The system will transfer this amount to the partner's
                    registered bank account.
                  </small>
                </CFormGroup>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <CFormGroup>
                  <CLabel className="text-dark font-weight-bold">
                    Transaction Remarks
                  </CLabel>
                  <CInput
                    placeholder="Add a note for this payout..."
                    className="text-dark border-secondary"
                    value={this.state.payoutNote}
                    onChange={(e) =>
                      this.setState({ payoutNote: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
            </CRow>
          </CModalBody>

          <CModalFooter className="bg-white">
            <CButton
              color="secondary"
              className="px-4"
              onClick={() => this.setState({ showPayoutModal: false })}
            >
              Cancel
            </CButton>
            <CButton
              color="info"
              className="px-4 font-weight-bold"
              onClick={this.handleExecutePayout}
              disabled={
                this.state.isProcessing ||
                !this.state.selectedBankLedgerId ||
                !this.state.selectedGateway
              }
            >
              {this.state.isProcessing
                ? "Processing..."
                : "Confirm & Send Money"}
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal
          show={this.state.sourceModalOpen}
          onClose={() => this.setState({ sourceModalOpen: false })}
          backdrop={false}
          closeOnBackdrop={false}
          size="md"
          style={{ zIndex: 1060 }}
        >
          <CModalHeader style={{ backgroundColor: "#303c54", color: "white" }}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <CModalTitle>Add Source Type</CModalTitle>
              <CButton
                onClick={() => this.setState({ sourceModalOpen: false })}
              >
                <img
                  src={closeKeImg}
                  alt="close"
                  width="20"
                  style={{ filter: "brightness(0) invert(1)" }}
                />
              </CButton>
            </div>
          </CModalHeader>
          <CModalBody>
            <CFormGroup>
              <CLabel>
                Enter Source Type <span className="text-danger">*</span>
              </CLabel>
              <CInput
                placeholder="Ex: REFERRAL, SOCIAL MEDIA"
                value={this.state.newSourceName}
                style={getValidationStyle(this.state.newSourceName)}
                invalid={this.state.sourceError}
                onChange={(e) =>
                  this.setState({
                    newSourceName: e.target.value.toUpperCase(),
                    sourceError: false,
                  })
                }
              />
            </CFormGroup>
            <CFormGroup>
              <CLabel>Status</CLabel>
              <CSelect
                value={this.state.newSourceStatus}
                onChange={(e) =>
                  this.setState({ newSourceStatus: e.target.value })
                }
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </CSelect>
            </CFormGroup>
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              onClick={() => this.setState({ sourceModalOpen: false })}
            >
              Cancel
            </CButton>
            <CButton color="info" onClick={this.handleQuickSaveSource}>
              {this.state.isProcessing ? "Saving..." : "Save"}
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal
          show={this.state.docModal}
          onClose={() => this.setState({ docModal: false })}
          size="lg"
          backdrop={false}
          closeOnBackdrop={false}
        >
          <CModalHeader style={{ backgroundColor: "#303c54", color: "white" }}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <CModalTitle>
                Documents: {this.state.selectedPartnerName}
              </CModalTitle>
              <CButton
                onClick={() => this.setState({ docModal: false })}
                style={{ background: "transparent", border: "none" }}
              >
                <img
                  src={closeKeImg}
                  alt="close"
                  width="20"
                  style={{ filter: "brightness(0) invert(1)" }}
                />
              </CButton>
            </div>
          </CModalHeader>

          <CModalBody>
            <GlobalLoader isLoading={this.state.isProcessingDoc} />

            <div
              className="p-3 mb-4 bg-white border rounded shadow-sm"
              style={{ borderLeft: "4px solid #303c54" }}
            >
              <h6 className="text-muted small font-weight-bold text-uppercase mb-3">
                Add New Document
              </h6>
              <CRow className="align-items-end">
                <CCol md="5">
                  <CLabel className="small font-weight-bold">
                    1. Select Document Type
                  </CLabel>
                  <CSelect
                    value={this.state.currentDocType}
                    onChange={(e) =>
                      this.setState({ currentDocType: e.target.value })
                    }
                  >
                    <option value="">-- Select --</option>
                    <option value="PAN Card">PAN Card</option>
                    <option value="Aadhar Card">Aadhar Card</option>
                    <option value="GST Certificate">GST Certificate</option>
                    <option value="Agreement">Agreement</option>
                    <option value="Bank Detail">Bank Detail</option>
                    <option value="Other">Other</option>
                  </CSelect>
                </CCol>
                <CCol md="5">
                  <CLabel className="small font-weight-bold">
                    2. Upload File
                  </CLabel>
                  <input
                    type="file"
                    ref={this.docFileInputRef}
                    style={{ display: "none" }}
                    onChange={this.handleDocFileChange}
                  />
                  <CButton
                    color="info"
                    block
                    disabled={!this.state.currentDocType}
                    onClick={() => this.docFileInputRef.current.click()}
                    className="text-white"
                  >
                    <FaFileUpload className="mr-2" />
                    {this.state.currentDocType
                      ? `Attach ${this.state.currentDocType}`
                      : "Select Type First"}
                  </CButton>
                </CCol>
              </CRow>
            </div>

            <div className="table-responsive bg-white border rounded">
              <table className="table table-sm mb-0">
                <thead style={{ backgroundColor: "#ebedef" }}>
                  <tr>
                    <th className="p-2">Document Type</th>
                    <th className="p-2">File Name</th>
                    <th className="p-2 text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.uploadedDocuments.length > 0 ? (
                    this.state.uploadedDocuments.map((doc) => (
                      <tr key={doc.id}>
                        <td className="p-2 align-middle">
                          <CBadge variant="outline">{doc.docType}</CBadge>
                        </td>
                        <td
                          className="p-2 align-middle text-truncate"
                          style={{ maxWidth: "200px" }}
                        >
                          {doc.file ? doc.file.name : "View File"}
                        </td>
                        <td className="p-2 text-center align-middle">
                          <CButton
                            size="sm"
                            onClick={() => window.open(doc.preview, "_blank")}
                          >
                            <FaEye className="text-info" />
                          </CButton>
                          <CButton
                            size="sm"
                            onClick={() => this.handleDeleteDoc(doc)}
                          >
                            <FaTrashAlt className="text-danger" />
                          </CButton>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center p-4 text-muted">
                        No documents attached yet.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </CModalBody>

          <CModalFooter>
            <CButton
              color="secondary"
              onClick={() => this.setState({ docModal: false })}
            >
              Cancel
            </CButton>
            <CButton color="info" onClick={this.handleSavePartnerDocs}>
              Save Changes
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          show={this.state.docDeleteModal}
          onClose={() => this.setState({ docDeleteModal: false })}
          size="sm"
          color="danger"
          backdrop={false}
          closeOnBackdrop={false}
        >
          <CModalHeader style={{ backgroundColor: "#303c54", color: "white" }}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <CModalTitle>Confirm Delete</CModalTitle>
              <CButton
                onClick={() => this.setState({ deleteModal: false })}
                style={{
                  background: "transparent",
                  border: "none",
                  padding: 0,
                }}
              >
                <img
                  src={closeKeImg}
                  alt="close"
                  width="20"
                  style={{ filter: "brightness(0) invert(1)" }}
                />
              </CButton>
            </div>
          </CModalHeader>
          <CModalBody className="py-4">
            Are you sure you want to delete this document?
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              onClick={() => this.setState({ docDeleteModal: false })}
            >
              Cancel
            </CButton>
            <CButton color="danger" onClick={this.confirmDeleteDoc}>
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal
          show={this.state.messageAlert}
          onClose={() => this.setState({ messageAlert: false })}
          size="sm"
          backdrop={false}
          closeOnBackdrop={false}
        >
          <CModalHeader style={{ backgroundColor: "#303c54", color: "white" }}>
            <CModalTitle>Success</CModalTitle>

            <CButton
              onClick={() => this.setState({ messageAlert: false })}
              style={{ padding: 0 }}
            >
              <img
                src={closeKeImg}
                alt="close"
                width="20"
                height="20"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </CButton>
          </CModalHeader>
          <CModalBody className="text-center h5">
            {this.state.message}
          </CModalBody>
          <CModalFooter>
            <CButton color="info" onClick={() => this.handleSuccessOk()}>
              Ok
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          show={this.state.commissionModal}
          onClose={() => this.setState({ commissionModal: false })}
          size="md"
        >
          <CModalHeader style={{ backgroundColor: "#303c54", color: "white" }}>
            <CModalTitle>Edit Commission Setup</CModalTitle>
            <CButton onClick={() => this.setState({ commissionModal: false })}>
              <img
                src={closeKeImg}
                alt=""
                width="20"
                height="20"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </CButton>
          </CModalHeader>
          <CModalBody>
            <CRow>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Commission Type</CLabel>
                  <CSelect
                    value={this.state.override_calc_type}
                    onChange={(e) =>
                      this.setState({ override_calc_type: e.target.value })
                    }
                  >
                    <option value="">-- Select Type --</option>

                    {uniqueCommissionTypes.map((type, index) => (
                      <option key={index} value={type}>
                        {type}
                      </option>
                    ))}
                  </CSelect>
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>
                    Override Value <span className="text-danger">*</span>
                  </CLabel>
                  <CInput
                    type="number"
                    placeholder="0.00"
                    value={this.state.override_value}
                    onChange={(e) =>
                      this.setState({ override_value: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow className="mt-2">
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Commission Status</CLabel>
                  <CSelect
                    value={this.state.mapping_is_active}
                    onChange={(e) =>
                      this.setState({
                        mapping_is_active: parseInt(e.target.value),
                      })
                    }
                  >
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </CSelect>
                </CFormGroup>
              </CCol>
            </CRow>
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              onClick={() => this.setState({ commissionModal: false })}
            >
              Cancel
            </CButton>
            <CButton color="info" onClick={this.handleSaveCommission}>
              {this.state.isProcessing ? "Updating..." : "Update Commission"}
            </CButton>
          </CModalFooter>
        </CModal>
        {!isWidgetMode && (
          <div
            className="breadcrumb-bar d-flex align-items-center justify-content-between"
            style={{ width: "100%" }}
          >
            <div className="d-flex align-items-center">
              {loggedInRole !== "CHANNEL PARTNER" && (
                <>
                  <div
                    className="breadcrumb-item"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.props.history.push("../Organization/ChannelPartner")
                    }
                  >
                    Channel Partner List
                  </div>
                  <span
                    className="breadcrumb-separator"
                    style={{ margin: "0 8px" }}
                  >
                    &#8250;
                  </span>
                </>
              )}
              <div className="breadcrumb-item active">Partner Profile</div>
            </div>

            {loggedInRole !== "CHANNEL PARTNER" && (
              <div>
              <CButton
  color="dark"
  variant="outline"
  size="sm"
  onClick={() => {
    console.log("Channel Partner Data on Generate Link:", this.state.partnerData);
    this.setState({ embedModal: true });
  }}
  className="d-flex align-items-center"
>
  &lt;/&gt; Generate Partner Link
</CButton>
              </div>
            )}
          </div>
        )}
        <CRow xl="12">
          <CCol xl="3">
            <CCard>
              <CCardBody>
                <CRow style={{ justifyContent: "Center", padding: 0 }}>
                  <img
                    src={
                      partnerData?.partner_photo &&
                      partnerData.partner_photo !== "null"
                        ? (partnerData.partner_photo.startsWith("http")
                            ? partnerData.partner_photo
                            : S3_BUCKET_URL + partnerData.partner_photo) +
                          `?t=${Date.now()}`
                        : userPlaceholder
                    }
                    alt=""
                    className="rounded-circle"
                    width="100"
                    height="100"
                    style={{ objectFit: "cover", border: "1px solid #ddd" }}
                    onError={(e) => {
                      e.target.src = userPlaceholder;
                    }}
                  />
                </CRow>
                <CRow style={{ justifyContent: "Center", padding: 0 }}>
                  <h6>{partnerData?.partner_name}</h6>
                </CRow>

                <CRow style={{ justifyContent: "Center", padding: 0 }}>
                  <CTooltip
                    content={"Reset Password"}
                    placement={"bottom-end"}
                    color="primary"
                  >
                    <CButton
                      type="button"
                      onClick={() =>
                        this.setState({
                          resetModal: true,
                          isEditingPassword: false,
                          newPassword: "",
                        })
                      }
                    >
                      <img src={password} alt="" width="15" height="15" />
                    </CButton>
                  </CTooltip>
                  <CTooltip
                    content={"Edit"}
                    placement={"bottom-end"}
                    color="primary"
                  >
                    <CButton
                      type="button"
                      onClick={() => this.setEditData(partnerData)}
                    >
                      <img src={editw} alt="" width="15" height="15" />
                    </CButton>
                  </CTooltip>
                  {/* <CTooltip
                    content={"Close"}
                    placement={"bottom-end"}
                    color="primary"
                  >
                    <CButton
                      type="button"
                      onClick={() =>
                        this.props.history.push("/setup/ChannelPartner")
                      }
                    >
                      <img src={rclose} alt="" width="15" height="15" />
                    </CButton>
                  </CTooltip> */}
                </CRow>

                <CCardHeader className="mt-3">
                  <CRow
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingRight: 10,
                      paddingLeft: 10,
                    }}
                  >
                    <div>
                      <h6>Partner Id</h6>
                    </div>
                    <div>{partnerData?.partner_id}</div>
                  </CRow>
                </CCardHeader>
                <CCardHeader>
                  <CRow
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingRight: 10,
                      paddingLeft: 10,
                    }}
                  >
                    <div>
                      <h6>Phone</h6>
                    </div>
                    <div>{partnerData?.phone}</div>
                  </CRow>
                </CCardHeader>
                <CCardHeader>
                  <CRow
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingRight: 10,
                      paddingLeft: 10,
                    }}
                  >
                    <div>
                      <h6>Email</h6>
                    </div>
                    <div style={{ fontSize: "10px" }}>{partnerData?.email}</div>
                  </CRow>
                </CCardHeader>
                <CCardHeader>
                  <CRow
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "space-between",
                      paddingRight: 10,
                      paddingLeft: 10,
                    }}
                  >
                    <div>
                      <h6>Status</h6>
                    </div>
                    <div>
                      <CBadge color={this.getBadge(partnerData?.is_active)}>
                        {partnerData?.is_active === 1 ? "Active" : "Inactive"}
                      </CBadge>
                    </div>
                  </CRow>
                </CCardHeader>
              </CCardBody>
            </CCard>
          </CCol>

          <CCol xl="9">
            <CCard>
              <CCardBody>
                <CTabs>
                  <CNav variant="tabs">
                    <CNavItem>
                      <CNavLink>Profile</CNavLink>
                    </CNavItem>
                    <CNavItem>
                      <CNavLink>Documents</CNavLink>
                    </CNavItem>
                    <CNavItem>
                      <CNavLink>Customers</CNavLink>
                    </CNavItem>
                    <CNavItem>
                      <CNavLink onClick={this.handleCommissionLogTabClick}>
                        Commission Log
                      </CNavLink>
                    </CNavItem>
                    <CNavItem>
                      <CNavLink onClick={this.handleBillingTabClick}>
                        Billing
                      </CNavLink>
                    </CNavItem>
                  </CNav>
                  <CTabContent>
                    <CTabPane className="pt-3">
                      <CCard>
                        <CCardHeader
                          style={{ backgroundColor: "#303c54", color: "white" }}
                        >
                          <b>Personal Details</b>
                        </CCardHeader>
                        <CCardBody>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>Full Name</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.partner_name}</CCol>
                          </CRow>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>Date of Birth</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.dob}</CCol>
                          </CRow>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>GST Number</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.gst_number || "N/A"}</CCol>
                          </CRow>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>PAN Number</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.pan_number || "N/A"}</CCol>
                          </CRow>
                        </CCardBody>
                      </CCard>

                      <CCard>
                        <CCardHeader
                          style={{ backgroundColor: "#303c54", color: "white" }}
                        >
                          <b>Address Details</b>
                        </CCardHeader>
                        <CCardBody>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>Address</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.address_line1}</CCol>
                          </CRow>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>City</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.city}</CCol>
                          </CRow>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>State</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.state || "N/A"}</CCol>
                          </CRow>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>Pincode</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.pincode || "N/A"}</CCol>
                          </CRow>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>Country</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.country}</CCol>
                          </CRow>
                        </CCardBody>
                      </CCard>

                      <CCard>
                        <CCardHeader
                          style={{ backgroundColor: "#303c54", color: "white" }}
                        >
                          <b>Bank Details</b>
                        </CCardHeader>
                        <CCardBody>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>Bank Name</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.bank_name || "N/A"}</CCol>
                          </CRow>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>Account No.</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.bank_account_no || "N/A"}</CCol>
                          </CRow>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>IFSC Code</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.bank_ifsc || "N/A"}</CCol>
                          </CRow>
                          <CRow className="mb-2">
                            <CCol md="4">
                              <b>UPI ID</b>
                            </CCol>{" "}
                            <CCol>{partnerData?.upi_id || "N/A"}</CCol>
                          </CRow>
                        </CCardBody>
                      </CCard>
                    </CTabPane>
                    <CTabPane className="pt-3">
                      <CCard>
                        <CCardHeader
                          style={{ backgroundColor: "#303c54", color: "white" }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <h5 className="mb-0" style={{ color: "white" }}>
                              Partner Documents
                            </h5>
                            <CButton
                              color="info"
                              size="sm"
                              onClick={() => this.openDocModal(partnerData)}
                            >
                              + Add Document
                            </CButton>
                          </div>
                        </CCardHeader>
                        <CCardBody style={{ backgroundColor: "#f8f9fa" }}>
                          <CRow>
                            {this.props.channelPartnerDocList &&
                            this.props.channelPartnerDocList.filter(
                              (doc) =>
                                String(doc.partner_id) ===
                                String(partnerData?.partner_id),
                            ).length > 0 ? (
                              this.props.channelPartnerDocList
                                .filter(
                                  (doc) =>
                                    String(doc.partner_id) ===
                                    String(partnerData?.partner_id),
                                )
                                .map((doc, index) => {
                                  const fileName =
                                    doc.Document.split("-").pop();
                                  const isPdf =
                                    doc.Document.toLowerCase().endsWith(".pdf");
                                  const isExcel =
                                    doc.Document.toLowerCase().endsWith(
                                      ".xlsx",
                                    ) ||
                                    doc.Document.toLowerCase().endsWith(".csv");

                                  return (
                                    <CCol md="6" key={doc.id} className="mb-3">
                                      <div className="d-flex align-items-center p-2 bg-white border rounded shadow-sm">
                                        <div
                                          className="mr-3 d-flex align-items-center justify-content-center bg-light rounded"
                                          style={{
                                            width: "50px",
                                            height: "50px",
                                          }}
                                        >
                                          <FaFileAlt
                                            className={
                                              isPdf
                                                ? "text-danger"
                                                : isExcel
                                                  ? "text-success"
                                                  : "text-info"
                                            }
                                            size={24}
                                          />
                                        </div>

                                        <div className="flex-grow-1 overflow-hidden">
                                          <h6
                                            className="mb-0 text-dark font-weight-bold text-truncate"
                                            style={{ fontSize: "13px" }}
                                            title={fileName}
                                          >
                                            {fileName}
                                          </h6>
                                          <small className="text-muted">
                                            Type:{" "}
                                            <strong>{doc.Document_type}</strong>
                                          </small>
                                        </div>

                                        <div className="d-flex align-items-center ml-2">
                                          <CTooltip content="View / Download">
                                            <CButton
                                              size="sm"
                                              color="light"
                                              className="border text-primary"
                                              onClick={() =>
                                                window.open(
                                                  S3_BUCKET_URL + doc.Document,
                                                  "_blank",
                                                )
                                              }
                                            >
                                              <FaEye size={12} />
                                            </CButton>
                                          </CTooltip>
                                        </div>
                                      </div>
                                    </CCol>
                                  );
                                })
                            ) : (
                              <CCol md="12" className="text-center py-5">
                                <p className="text-muted">
                                  No documents found for this partner.
                                </p>
                              </CCol>
                            )}
                          </CRow>
                        </CCardBody>
                      </CCard>
                    </CTabPane>
                    <CTabPane className="pt-3">
                      <CCard>
                        <CCardHeader
                          style={{ backgroundColor: "#303c54", color: "white" }}
                        >
                          <h5>Associated Customers</h5>
                        </CCardHeader>
                        <CCardBody>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="col-md-4 p-0">
                              <CInputGroup>
                                <CInputGroupText>
                                  <CIcon
                                    size="sm"
                                    name="cil-magnifying-glass"
                                  />
                                </CInputGroupText>
                                <CInput
                                  type="text"
                                  placeholder="Search by Name or Phone..."
                                  value={this.state.customerSearchText}
                                  onChange={(e) =>
                                    this.setState({
                                      customerSearchText: e.target.value,
                                    })
                                  }
                                />
                              </CInputGroup>
                            </div>
                            <div className="d-flex align-items-center">
                              <CCol
                                onClick={this.copyToClipboard}
                                style={{ cursor: "pointer" }}
                              >
                                <CTooltip content="Copy">
                                  <img src={copy} width="15" />
                                </CTooltip>
                              </CCol>
                              <CCol
                                onClick={this.exportToExcel}
                                style={{ cursor: "pointer" }}
                              >
                                <CTooltip content="Excel">
                                  <img src={excel} width="15" />
                                </CTooltip>
                              </CCol>
                              <CCol
                                onClick={this.exportToCSV}
                                style={{ cursor: "pointer" }}
                              >
                                <CTooltip content="CSV">
                                  <img src={csv} width="15" />
                                </CTooltip>
                              </CCol>
                              <CCol
                                onClick={this.exportToPDF}
                                style={{ cursor: "pointer" }}
                              >
                                <CTooltip content="Pdf">
                                  <img src={pdf} width="15" />
                                </CTooltip>
                              </CCol>
                              <CCol
                                onClick={this.handlePrint}
                                style={{ cursor: "pointer" }}
                              >
                                <CTooltip content="Print">
                                  <img src={print} width="15" />
                                </CTooltip>
                              </CCol>
                            </div>
                          </div>

                          <CDataTable
                            items={myCustomers}
                            fields={[
                              {
                                key: "FirstName",
                                label: "Customer",
                                _style: { width: "40%" },
                              },
                              { key: "PhoneNumber", label: "Phone" },
                              { key: "ProductName", label: "Product" },
                              { key: "paymentStatus", label: "Status" },
                              {
                                key: "Action",
                                label: "Action",
                                _style: { textAlign: "center" },
                              },
                            ]}
                            hover
                            striped
                            bordered
                            size="sm"
                            itemsPerPage={10}
                            pagination
                            scopedSlots={{
                              FirstName: (item) => (
                                <td className="align-middle">
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      this.handleCustomerClick(item)
                                    }
                                  >
                                    <img
                                      src={
                                        item.ProfilePhoto
                                          ? S3_BUCKET_URL + item.ProfilePhoto
                                          : user
                                      }
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        marginRight: "12px",
                                        border: "1px solid #dee2e6",
                                      }}
                                      onError={(e) => {
                                        e.target.src = user;
                                      }}
                                    />
                                    <div>
                                      <div
                                        className="font-weight-bold text-primary"
                                        style={{ lineHeight: "1.2" }}
                                      >
                                        {item.id}{" "}
                                        <span className="text-dark">|</span>{" "}
                                        {item.FirstName} {item.LastName}
                                      </div>
                                      <small className="text-muted">
                                        {item.Email || "No Email"}
                                      </small>
                                    </div>
                                  </div>
                                </td>
                              ),
                              Action: (item) => (
                                <td className="text-center align-middle">
                                  <div className="d-flex justify-content-center">
                                    <CTooltip content="Admin Panel">
                                      <CButton
                                        size="sm"
                                        className="p-1 mx-1"
                                        onClick={() =>
                                          this.handleAccountAdminClick(item)
                                        }
                                      >
                                        <CIcon name="cil-settings" />
                                      </CButton>
                                    </CTooltip>
                                  </div>
                                </td>
                              ),
                            }}
                          />
                        </CCardBody>
                      </CCard>
                    </CTabPane>
                    <CTabPane className="pt-3">
                      <CCard>
                        <CCardHeader
                          style={{ backgroundColor: "#303c54", color: "white" }}
                        >
                          <h5>Commission Logs</h5>
                        </CCardHeader>
                        <CCardBody>
                          <CDataTable
                            items={this.props.commissionLogList || []}
                            fields={[
                              {
                                key: "id",
                                label: "Log ID",
                                _style: { width: "10%" },
                              },
                              {
                                key: "sales_order_id",
                                label: "Sales Order ID",
                                _style: { width: "15%" },
                              },
                              {
                                key: "trigger_type",
                                label: "Trigger Type",
                                _style: { width: "20%" },
                              },
                              {
                                key: "commission_amount",
                                label: "Amount (INR)",
                                _style: { width: "15%" },
                              },
                              {
                                key: "status",
                                label: "Status",
                                _style: { width: "15%" },
                              },
                              {
                                key: "created_at",
                                label: "Date Added",
                                _style: { width: "15%" },
                              },
                              {
                                key: "action",
                                label: "Actions",
                                _style: { width: "10%", textAlign: "center" },
                              },
                            ]}
                            hover
                            striped
                            bordered
                            size="sm"
                            itemsPerPage={10}
                            pagination
                            scopedSlots={{
                              commission_amount: (item) => (
                                <td className="align-middle font-weight-bold text-success">
                                  ₹
                                  {parseFloat(
                                    item.commission_amount,
                                  ).toLocaleString()}
                                </td>
                              ),
                              status: (item) => (
                                <td className="align-middle">
                                  <CBadge
                                    color={
                                      item.status === "APPROVED" ||
                                      item.status === "PAID"
                                        ? "success"
                                        : item.status === "PENDING"
                                          ? "warning"
                                          : "danger"
                                    }
                                  >
                                    {item.status}
                                  </CBadge>
                                </td>
                              ),
                              created_at: (item) => (
                                <td className="align-middle text-muted">
                                  {item.created_at
                                    ? new Date(
                                        item.created_at,
                                      ).toLocaleDateString()
                                    : "N/A"}
                                </td>
                              ),
                              action: (item) => (
                                <td className="text-center align-middle">
                                  {item.status === "PENDING" ? (
                                    <div className="d-flex justify-content-center">
                                      <CButton
                                        size="sm"
                                        color="success"
                                        className="mr-1 py-0 px-1 text-white text-uppercase"
                                        style={{ fontSize: "10px" }}
                                        onClick={() =>
                                          this.handleUpdateCommissionStatus(
                                            item.id,
                                            "APPROVED",
                                          )
                                        }
                                      >
                                        Approve
                                      </CButton>
                                      <CButton
                                        size="sm"
                                        color="danger"
                                        className="py-0 px-1 text-white text-uppercase"
                                        style={{ fontSize: "10px" }}
                                        onClick={() =>
                                          this.handleUpdateCommissionStatus(
                                            item.id,
                                            "REJECTED",
                                          )
                                        }
                                      >
                                        Reject
                                      </CButton>
                                    </div>
                                  ) : (
                                    <span className="text-muted small">-</span>
                                  )}
                                </td>
                              ),
                            }}
                          />
                        </CCardBody>
                      </CCard>
                    </CTabPane>
                    <CTabPane className="pt-3">
                      <CCard>
                        <CCardHeader
                          style={{ backgroundColor: "#303c54", color: "white" }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <h5 className="mb-0" style={{ color: "white" }}>
                              Payout & Billing
                            </h5>
                          </div>
                        </CCardHeader>
                        <CCardBody>
                          {(() => {
                            const balance = this.props
                              .channelPartnerPayoutBalance || {
                              currentBalance: 0,
                              stuckAmount: 0,
                              approvedCommissions: 0,
                              safeBalance: 0,
                            };
                            return (
                              <CRow className="mb-4">
                                <CCol md="3">
                                  <CCard className="text-center border-0 shadow-sm bg-info text-white mb-2">
                                    <CCardBody className="p-3">
                                      <div
                                        className="text-uppercase small font-weight-bold"
                                        style={{ opacity: 0.9 }}
                                      >
                                        Approved Commissions
                                      </div>
                                      <h3 className="font-weight-bold mt-2">
                                        ₹
                                        {parseFloat(
                                          balance.approvedCommissions || 0,
                                        ).toLocaleString()}
                                      </h3>
                                    </CCardBody>
                                  </CCard>
                                </CCol>
                                <CCol md="3">
                                  <CCard className="text-center border-0 shadow-sm bg-danger text-white mb-2">
                                    <CCardBody className="p-3">
                                      <div
                                        className="text-uppercase small font-weight-bold"
                                        style={{ opacity: 0.9 }}
                                      >
                                        Stuck Amount
                                      </div>
                                      <h3 className="font-weight-bold mt-2">
                                        ₹
                                        {parseFloat(
                                          balance.stuckAmount || 0,
                                        ).toLocaleString()}
                                      </h3>
                                    </CCardBody>
                                  </CCard>
                                </CCol>
                                <CCol md="3">
                                  <CCard className="text-center border-0 shadow-sm bg-secondary text-dark mb-2">
                                    <CCardBody className="p-3">
                                      <div
                                        className="text-uppercase small font-weight-bold"
                                        style={{ opacity: 0.8 }}
                                      >
                                        Current Balance
                                      </div>
                                      <h3 className="font-weight-bold mt-2">
                                        ₹
                                        {parseFloat(
                                          balance.currentBalance || 0,
                                        ).toLocaleString()}
                                      </h3>
                                    </CCardBody>
                                  </CCard>
                                </CCol>
                                <CCol md="3">
                                  <CCard className="text-center border-0 shadow-sm bg-success text-white mb-2">
                                    <CCardBody className="p-3">
                                      <div
                                        className="text-uppercase small font-weight-bold"
                                        style={{ opacity: 0.9 }}
                                      >
                                        Safe Balance
                                      </div>
                                      <h3 className="font-weight-bold mt-2">
                                        ₹
                                        {parseFloat(
                                          balance.safeBalance || 0,
                                        ).toLocaleString()}
                                      </h3>
                                    </CCardBody>
                                  </CCard>
                                </CCol>
                              </CRow>
                            );
                          })()}
                          <div className="mt-4 p-4 bg-light border-top d-flex justify-content-between align-items-center shadow-sm">
                            <div>
                              <p className="mb-0 text-muted text-uppercase small font-weight-bold">
                                Safe Balance Available
                              </p>
                              <h3 className="text-success font-weight-bold">
                                INR{" "}
                                {(
                                  this.props.channelPartnerPayoutBalance
                                    ?.safeBalance || 0
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                })}
                              </h3>
                            </div>

                            <CButton
                              color="info"
                              size="sm"
                              className="px-2 shadow font-weight-bold"
                              onClick={() => {
                                const balance =
                                  this.props.channelPartnerPayoutBalance
                                    ?.safeBalance || 0;
                                this.setState({
                                  showPayoutModal: true,
                                  payoutAmount: parseFloat(balance).toFixed(2),
                                  maxPayoutAmount:
                                    parseFloat(balance).toFixed(2),
                                });
                              }}
                            >
                              <CIcon name="cil-check" className="mr-2" />{" "}
                              Disburse Funds
                            </CButton>
                          </div>
                        </CCardBody>
                      </CCard>
                    </CTabPane>
                  </CTabContent>
                </CTabs>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <style>
          {`
          .drawer-overlay {
            position: fixed; top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0, 0, 0, 0.4); z-index: 1060;
            display: none; opacity: 0; transition: opacity 0.3s ease;
          }
          .drawer-overlay.show {
            display: block; opacity: 1;
          }
          .side-drawer {
            position: fixed; top: 0; right: 0; height: 100vh;
            background: #fff; z-index: 1061;
            box-shadow: -4px 0 28px rgba(0, 0, 0, 0.18);
            display: flex; flex-direction: column; overflow: hidden;
            transform: translateX(100%); 
            transition: transform 0.32s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .side-drawer.show {
            transform: translateX(0); 
          }
          `}
        </style>

        <div
          className={`drawer-overlay ${this.state.modaladdproject ? "show" : ""}`}
          onClick={() => this.setState({ modaladdproject: false })}
        />

        <div
          className={`side-drawer ${this.state.modaladdproject ? "show" : ""}`}
          style={{ width: "750px" }}
        >
          <div
            className="drawer-header d-flex justify-content-between align-items-center"
            style={{
              backgroundColor: "#303c54",
              color: "white",
              padding: "15px 20px",
            }}
          >
            <div style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
              {this.state.btn} Channel Partner
            </div>

            <CButton
              className="p-0 border-0 shadow-none"
              onClick={() => this.setState({ modaladdproject: false })}
            >
              <img
                src={closeKeImg}
                alt="close"
                width="20"
                height="20"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </CButton>
          </div>

          <div
            className="drawer-body"
            style={{ padding: "20px", flex: 1, overflowY: "auto" }}
          >
            <CRow>
              <CCol md="6">
                <CFormGroup
                  style={{ position: "relative" }}
                  innerRef={this.channelRef}
                >
                  <CLabel>
                    Designation <span className="text-danger">*</span>
                  </CLabel>
                  <CInput
                    placeholder="Search Sales Channel..."
                    style={getValidationStyle(this.state.channel_id)}
                    value={this.state.channelSearch}
                    onFocus={() => this.setState({ showChannelDrop: true })}
                    onChange={(e) =>
                      this.setState({
                        channelSearch: e.target.value,
                        showChannelDrop: true,
                      })
                    }
                  />
                  {this.state.showChannelDrop && (
                    <ul style={dropdownStyles}>
                      {filteredChannels.map((c) => (
                        <li
                          key={c.id}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                          onClick={() => {
                            const mappedProductRows = (
                              c.product_mapping || []
                            ).map((pm) => {
                              const product = this.props.productList.find(
                                (p) => String(p.id) === String(pm.product_id),
                              );
                              return {
                                product_group: pm.group_name || "",
                                product_id: pm.product_id || "",
                                product_name: product
                                  ? product.Name
                                  : "Product Not Found",
                              };
                            });
                            this.setState({
                              channel_id: c.id,
                              channelSearch: c.channel_name,
                              channel_code: c.channel_code,
                              channel_name: c.channel_name,
                              sold_by: c.sold_by,
                              invoice_to: c.invoice_to,
                              payment_received_by: c.payment_received_by,
                              is_commission_applicable:
                                c.is_commission_applicable.toString(),
                              selectedChannelInfo: c,
                              showChannelDrop: false,
                              slabs: c.slabs || [],
                              amc_records: c.amc_records || [],
                              amc_enabled:
                                c.amc_records && c.amc_records.length > 0,
                              components: c.components || [],
                              acl_enabled:
                                c.components && c.components.length > 0,
                              product_mapping_enabled:
                                mappedProductRows.length > 0,
                              selected_product_rows: mappedProductRows,
                            });
                          }}
                        >
                          {c.channel_name} ({c.channel_code})
                        </li>
                      ))}
                    </ul>
                  )}
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Payment & Default Commission</CLabel>
                  <CInput
                    disabled
                    className="bg-light"
                    value={
                      this.state.selectedChannelInfo
                        ? `${this.state.selectedChannelInfo.payment_received_by || "N/A"}, ${this.state.selectedChannelInfo.default_commission_value || "0"}`
                        : ""
                    }
                    placeholder="Select Designation above"
                  />
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>
                    First Name <span className="text-danger">*</span>
                  </CLabel>
                  <CInput
                    placeholder="Enter First Name"
                    style={getValidationStyle(this.state.partner_name)}
                    value={this.state.partner_name}
                    onChange={(e) =>
                      this.setState({ partner_name: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>
                    Last Name <span className="text-danger">*</span>
                  </CLabel>
                  <CInput
                    placeholder="Enter Last Name"
                    value={this.state.last_name}
                    onChange={(e) =>
                      this.setState({ last_name: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>
                    Phone <span className="text-danger">*</span>
                  </CLabel>
                  <CInput
                    placeholder="Enter Phone"
                    style={getValidationStyle(this.state.phone)}
                    value={this.state.phone}
                    onChange={(e) => this.setState({ phone: e.target.value })}
                  />
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>
                    Email <span className="text-danger">*</span>
                  </CLabel>
                  <CInput
                    placeholder="Enter Email"
                    style={getValidationStyle(this.state.email)}
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                  />
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>
                    Date of Birth <span className="text-danger">*</span>
                  </CLabel>
                  <CInput
                    type="date"
                    style={getValidationStyle(this.state.dob)}
                    value={this.state.dob}
                    onChange={(e) => this.setState({ dob: e.target.value })}
                  />
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Address Line </CLabel>
                  <CInput
                    placeholder="Enter Address"
                    value={this.state.address_line1}
                    onChange={(e) =>
                      this.setState({ address_line1: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <CFormGroup
                  style={{ position: "relative" }}
                  innerRef={this.countryRef}
                >
                  <CLabel>Country</CLabel>
                  <CInput
                    placeholder="Search Country..."
                    value={this.state.countrySearch}
                    onFocus={() => this.setState({ showCountryDrop: true })}
                    onChange={(e) =>
                      this.setState({
                        countrySearch: e.target.value,
                        showCountryDrop: true,
                      })
                    }
                  />
                  {this.state.showCountryDrop && (
                    <ul style={dropdownStyles}>
                      {filteredCountries.map((c) => (
                        <li
                          key={c.shortName}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                          onClick={() => this.handleCountrySelect(c)}
                        >
                          {c.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup
                  style={{ position: "relative" }}
                  innerRef={this.stateRef}
                >
                  <CLabel>State</CLabel>
                  <CInput
                    placeholder="Search State..."
                    value={this.state.stateSearch}
                    disabled={!this.state.country}
                    onFocus={() => this.setState({ showStateDrop: true })}
                    onChange={(e) =>
                      this.setState({
                        stateSearch: e.target.value,
                        showStateDrop: true,
                      })
                    }
                  />
                  {this.state.showStateDrop && (
                    <ul style={dropdownStyles}>
                      {filteredStates.map((p) => (
                        <li
                          key={p}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                          onClick={() => this.handleStateSelect(p)}
                        >
                          {p}
                        </li>
                      ))}
                    </ul>
                  )}
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <CFormGroup
                  style={{ position: "relative" }}
                  innerRef={this.cityRef}
                >
                  <CLabel>City</CLabel>
                  <CInput
                    placeholder="Search City..."
                    value={this.state.citySearch}
                    disabled={!this.state.state}
                    onFocus={() => this.setState({ showCityDrop: true })}
                    onChange={(e) =>
                      this.setState({
                        citySearch: e.target.value,
                        showCityDrop: true,
                      })
                    }
                  />
                  {this.state.showCityDrop && (
                    <ul style={dropdownStyles}>
                      {filteredCities.map((city) => (
                        <li
                          key={city}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                          onClick={() =>
                            this.setState({
                              city: city,
                              citySearch: city,
                              showCityDrop: false,
                            })
                          }
                        >
                          {city}
                        </li>
                      ))}
                    </ul>
                  )}
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Pincode</CLabel>
                  <CInput
                    placeholder="Enter Pincode"
                    value={this.state.pincode}
                    onChange={(e) => this.setState({ pincode: e.target.value })}
                  />
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>GST Number</CLabel>
                  <CInput
                    placeholder="Enter Gst"
                    value={this.state.gst_number}
                    onChange={(e) =>
                      this.setState({ gst_number: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>PAN Number</CLabel>
                  <CInput
                    placeholder="Enter Pan"
                    value={this.state.pan_number}
                    onChange={(e) =>
                      this.setState({ pan_number: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Bank Name</CLabel>
                  <CInput
                    placeholder="Enter Bank"
                    value={this.state.bank_name}
                    onChange={(e) =>
                      this.setState({ bank_name: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Account No</CLabel>
                  <CInput
                    placeholder="Enter Account No"
                    value={this.state.bank_account_no}
                    onChange={(e) =>
                      this.setState({ bank_account_no: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>IFSC Code</CLabel>
                  <CInput
                    placeholder="Enter IFSC Code"
                    value={this.state.bank_ifsc}
                    onChange={(e) =>
                      this.setState({ bank_ifsc: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>UPI ID</CLabel>
                  <CInput
                    placeholder="Enter UPI ID"
                    value={this.state.upi_id}
                    onChange={(e) => this.setState({ upi_id: e.target.value })}
                  />
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Status</CLabel>
                  <CSelect
                    value={this.state.is_active}
                    onChange={(e) =>
                      this.setState({ is_active: parseInt(e.target.value) })
                    }
                  >
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </CSelect>
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Security Deposit Amount</CLabel>
                  <CInput
                    type="number"
                    placeholder="0.00"
                    value={this.state.security_deposit_amount}
                    disabled={isChannelPartner}
                    onChange={(e) =>
                      this.setState({ security_deposit_amount: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Organization Name</CLabel>
                  <CInput
                    placeholder="Enter Organization Name"
                    value={this.state.system_name}
                    onChange={(e) =>
                      this.setState({ system_name: e.target.value })
                    }
                  />
                </CFormGroup>
              </CCol>

              <CCol md="6">
                <CFormGroup style={{ position: "relative" }}>
                  <CLabel>
                    Source Type <span className="text-danger">*</span>
                  </CLabel>
                  <div className="d-flex">
                    <div
                      style={{ flex: 1, position: "relative" }}
                      ref={this.sourceRef}
                    >
                      <CInput
                        placeholder="Search Source..."
                        value={this.state.sourceSearch}
                        style={{
                          borderColor:
                            this.state.newSourceName === "" ||
                            this.state.newSourceName === null ||
                            this.state.newSourceName === undefined ||
                            this.state.sourceError
                              ? "red"
                              : "#d8dbe0",
                        }}
                        disabled={isChannelPartner}
                       
                        onFocus={() =>
                          !isChannelPartner &&
                          this.setState({ showSourceDrop: true })
                        }
                        onChange={(e) =>
                          !isChannelPartner &&
                          this.setState({
                            sourceSearch: e.target.value,
                            showSourceDrop: true,
                          })
                        }
                      />
                      {this.state.showSourceDrop && (
                        <ul style={{ ...dropdownStyles, zIndex: 1050 }}>
                          {(this.props.sourceTypeList || [])
                            .filter((s) => s.action === 1 || s.Action === 1)
                            .filter(
                              (s) =>
                                s.sourceType &&
                                s.sourceType
                                  .toLowerCase()
                                  .includes(
                                    this.state.sourceSearch.toLowerCase(),
                                  ),
                            )
                            .map((s, idx) => (
                              <li
                                key={idx}
                                style={{
                                  padding: "8px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #eee",
                                }}
                                onClick={() =>
                                  this.handleSourceSelect({
                                    source_name: s.sourceType,
                                  })
                                }
                              >
                                {s.sourceType}
                              </li>
                            ))}
                        </ul>
                      )}
                    </div>

                    <CButton
                      color="info"
                      size="sm"
                      className="ml-1 text-white"
                      style={{ height: "35px" }}
                      disabled={isChannelPartner}
                      onClick={() =>
                        this.setState({
                          modaladdproject: false,
                          sourceModalOpen: true,
                          newSourceName: "",
                          sourceError: false,
                        })
                      }
                    >
                      +
                    </CButton>
                  </div>

                  <div className="mt-2 d-flex flex-wrap">
                    {this.state.selectedSources.map((src, index) => (
                      <CBadge
                        key={index}
                        color="info"
                        className="mr-1 mb-1 p-2 d-flex align-items-center"
                        style={{ fontSize: "12px" }}
                      >
                        {src}
                        {!isChannelPartner && (
                          <span
                            className="ml-2"
                            style={{ cursor: "pointer", fontWeight: "bold" }}
                            onClick={() => this.removeSource(src)}
                          >
                            ×
                          </span>
                        )}
                      </CBadge>
                    ))}
                  </div>
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow className="align-items-center mt-3">
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Organization Logo</CLabel>
                  <CInputFile
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        this.setState({
                          system_logo: file,
                          system_logo_path: URL.createObjectURL(file),
                          displaySystemLogo: true,
                        });
                      }
                    }}
                  />
                </CFormGroup>
              </CCol>
              <CCol md="5">
                <div
                  style={{
                    width: "100%",
                    height: "100px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    overflow: "hidden",
                    backgroundColor: "#f8f9fa",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {this.state.displaySystemLogo ? (
                    <img
                      src={this.state.system_logo_path}
                      alt="preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : this.state.system_logo ? (
                    <img
                      src={`${S3_BUCKET_URL}${this.state.system_logo}`}
                      alt="logo"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <div className="text-muted small">No Logo</div>
                  )}
                </div>
              </CCol>
            </CRow>

            <CRow className="align-items-center mt-3">
              <CCol md="6">
                <CFormGroup>
                  <CLabel>Partner Photo</CLabel>
                  <CInputFile
                    key={this.state.fileInputKey}
                    onChange={this.handleImageChange}
                  />
                </CFormGroup>
              </CCol>
              <CCol md="6">
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#f0f0f0",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={this.state.partner_photo_path || user}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      alt="Preview"
                      onError={(e) => {
                        e.target.src = user;
                      }}
                    />
                  </div>
                </div>
              </CCol>
            </CRow>
          </div>

          <div
            className="drawer-footer d-flex justify-content-end align-items-center"
            style={{ padding: "15px 20px", borderTop: "1px solid #ddd" }}
          >
            <CButton
              color="secondary"
              onClick={() => this.setState({ modaladdproject: false })}
            >
              Cancel
            </CButton>
            <CButton
              color="info"
              className="ml-2"
              onClick={this.handleUpdatePartner}
            >
              {this.state.btn}
            </CButton>
          </div>
        </div>

        <CModal
          show={this.state.deleteModal}
          onClose={() => this.setState({ deleteModal: false })}
          color="danger"
          backdrop={false}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>Confirm Delete</CModalTitle>
          </CModalHeader>
          <CModalBody>
            Are you sure you want to delete this partner profile?
          </CModalBody>
          <CModalFooter>
            <CButton color="danger" onClick={this.confirmDelete}>
              Delete
            </CButton>
            <CButton
              color="secondary"
              onClick={() => this.setState({ deleteModal: false })}
            >
              Cancel
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal
          show={this.state.embedModal}
          onClose={() => this.setState({ embedModal: false })}
          size="lg"
          backdrop={false}
          closeOnBackdrop={false}
        >
          <CModalHeader
            closeButton
            style={{ backgroundColor: "#303c54", color: "white" }}
          >
            <CModalTitle>Website Widget Integration</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="text-muted small">
              Copy the code below and paste it into your website's HTML to
              display your partner products.
            </p>

            <div className="d-flex align-items-center mb-3">
              <CInput
                type="text"
                readOnly
                value={`<iframe src="${window.location.origin}/#/standalone/partner-products/${localStorage.getItem("hospitalCode")}${(this.state.partnerData?.phone || "").replace(/\D/g, "")}${(this.state.partnerData?.dob || "").replace(/\D/g, "")}" width="100%" height="600px" style="border:none;"></iframe>`}
                style={{
                  backgroundColor: "#f8f9fa",
                  fontFamily: "monospace",
                  fontSize: "0.85rem",
                  color: "#303c54",
                  fontWeight: "500",
                }}
              />
              <CButton
                color="info"
                className="ml-2 text-white"
                onClick={this.handleCopyEmbedCode}
              >
                Copy
              </CButton>
            </div>

            <div className="mt-2 bg-light p-2 rounded border">
              <small className="d-block mb-1 font-weight-bold">
                Preview Link:
              </small>
              <small>
                <a
                  href={`${window.location.origin}/#/standalone/partner-products/${localStorage.getItem("hospitalCode")}${(this.state.partnerData?.phone || "").replace(/\D/g, "")}${(this.state.partnerData?.dob || "").replace(/\D/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info text-break"
                >
                  {`${window.location.origin}/#/standalone/partner-products/${localStorage.getItem("hospitalCode")}${(this.state.partnerData?.phone || "").replace(/\D/g, "")}${(this.state.partnerData?.dob || "").replace(/\D/g, "")}`}
                </a>
              </small>
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              onClick={() => this.setState({ embedModal: false })}
            >
              Close
            </CButton>
          </CModalFooter>
        </CModal>
        {this.renderCustomerDetailModal()}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  channelPartnerList:
    state.setuphospitalechannelpartnerReducer.channelPartnerList,
  channelPartnerMappingList:
    state.setuphospitalechannelpartnerReducer.channelPartnerMappingList,
  accountpersonalList: state.setuphospitaleaccountReducer.accountpersonalList,
  userGetData: state.loginReducer.userGetData,
  channelPartnerSetupList:
    state.setupChannelPartnerReducer.channelPartnerSetupList,
  AccountLedgerByIdList:
    state.setuphospitaleincomeReducer.AccountLedgerByIdList,
  AccountMainBankMasterList:
    state.setuphospitaleincomeReducer.AccountMainBankMasterList || [],
  paymentGetwayList: state.paymentGetwayReducer.getAllPaymentGetwayList,
  departmentList: state.setuphospitalehrsettingReducer.departmentList,
  salesordersList: state.setupsalesordersReducer.salesordersList || [],
  allTransactionList: state.TransactionReducer.allTransactionList || [],
  channelPartnerDocList:
    state.setuphospitalechannelpartnerReducer.channelPartnerDocList || [],
  AccountMainLedgerMasterList:
    state.setuphospitaleincomeReducer.AccountMainLedgerMasterList,
  channelpartnerpayoutList:
    state.channelPartnerPayoutReducer.channelpartnerpayoutList || [],
  channelPartnerPayoutBalance:
    state.setuphospitalechannelpartnerReducer?.channelPartnerPayoutBalance ||
    null,
  productList: state.setuphospitaleproductgroupReducer.productList,
  commissionLogList:
    state.channelPartnerCommissionLogReducer?.commissionLogList || [],
  commissionLogUpdateStatus:
    state.channelPartnerCommissionLogReducer?.commissionLogUpdateStatus || null,
  sourceTypeList: state.setupChannelPartnerReducer.sourceTypeList || [],
});

const mapDispatchToProps = {
  getChanelPartner,
  deleteChanelPartner,
  getAccountPersonal,
  getUser,
  updateChanelPartner,
  getChanelPartnerMapping,
  getChannelPartnerDoc,
  createChannelPartnerDoc,
  deleteChannelPartnerDoc,
  updateChanelPartnerMapping,
  getChannelPartnerSetup,
  updateUser,
  setSelectedAccountData,
  getAccountLedgerbyid,
  createChannelPrtnerPayout,
  getAccountMainBankMaster,
  getAllPaymentGetway,
  getDepartment,
  getSalesOrders,
  getAllTransaction,
  getAccountMainLedgerMaster,
  getChannelPrtnerPayout,
  getChannelPartnerPayoutBalance,
  getProduct,
  getChannelPartnerCommissionLog,
  updateChannelPartnerCommissionLog,
  getChannelPartnerSource,
  createChannelPartnerSource,
  createLink,
  sendMail,
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerProfile);
